import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Grid2, IconButton, InputAdornment, MenuItem, Modal, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography,  Stepper,Chip,
  Step,
  StepLabel, 
  CircularProgress} from "@mui/material";
import config from "../../config/config.js";
import { useNavigate } from "react-router-dom";
import React, { useRef, useState } from "react";
import TokenError from "../tokenError.jsx";
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import { useEffect } from "react";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import { Label } from "flowbite-react";
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';
import Paper from '@mui/material/Paper';
import altProfile from '../../assets/images/altProfile.png';
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import AutoMarker from '../../assets/images/AutoMarker.svg';
import BikeMarker from '../../assets/images/bikeMarker.svg';
import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import mapPin from '../../assets/icons/LocationPin.svg';
import SubtractCircleSvg from '../../assets/images/subtractCircleSvg.svg';
import CarMarker from '../../assets/images/carMarker.svg';
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader.js";
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo/DemoContainer.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import constants from '../../constant.js';
import LinearProgress from '@mui/material/LinearProgress';
import { useLocation } from "react-router-dom";
import DriverLabelMarker from '../dispatcher/DriverLabelMarker.jsx';
import tzlookup from "tz-lookup";
import { DateTime } from "luxon";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InboxIcon from '@mui/icons-material/Inbox';

export function convertUtcToLocal(lat, lng, utcTime) {
  const timezone = tzlookup(lat, lng);
  const localTime = DateTime
    .fromISO(utcTime, { zone: "utc" })
    .setZone(timezone);

  return {
    timezone,
    localTime: localTime.toFormat("yyyy-MM-dd hh:mm a"),
    offset: localTime.offset / 60
  };
}

// Your static data
const CALGARY_AIRPORT_PLACE_ID = 'ChIJdzv2ew9kcVMRV3S8XB-H6ds';
const AIRPORT_TERMINALS = [
  {
    place_id: 'terminal_1_static', // Custom ID
    description: 'Domestic Terminal (Terminal 1)',
    title: 'Domestic Terminal (Terminal 1), Calgary International Airport, 2000 Airport Rd NE, Calgary, AB T2E 6W5, Canada',
    // Add other data you need upon selection
    latitude: 51.1305,
    longitude: -114.0107,
  },
  {
    place_id: 'terminal_2_static', // Custom ID
    description: 'International Terminal (Terminal 2)',
    title: 'International Terminal (Terminal 2), Calgary International Airport, 2000 Airport Rd NE, Calgary, AB T2E 6W5, Canada',
    latitude: 51.1286,
    longitude: -114.0064,
  },
];

const ScheduledBookings = () => {

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const autosUrl = config.autosUrl;
    const navigate = useNavigate();
    const location = useLocation();
    const search = location.search.replace(/\?/g, '&').replace('&', '?');
    const params = new URLSearchParams(search);
    const queryCityId = params.get("city_id");
    const queryRideId = params.get("ride_id"); 
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(() => {return queryCityId || cities[0]?.city_id;});
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows, setRows] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('ride_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(50);
    const [filteredRows, setFilteredRows] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    const [openAssignModal, setOpenAssignModal] = useState(false);
    const [assignDriver, setAssignDriver] = useState('');
    const [driversData, setDriversData] = useState([]);
    const [assigningDrivers, setAssigningDrivers] = useState(false);
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [rideId, setRideId] = useState('');
    const [notificationRideId, setNotificationRideId] = useState('');
    const [noDriverMessage, setNoDriverMessage] = useState('');
    const [isReassign, setIsReassign] = useState(false);
    const [engagementId, setEngagementId] = useState('');
    const [refundPercentage, setRefundPercentage] = useState(0);
    const [openUnassign, setOpenUnassign] = useState(false);
    const [isUnassign, setIsUnassign] = useState(false);
    const [driverId, setDriverId] = useState('');
    const [openAddModal, setOpenAddModal] = useState(false);
    const [vehicleId, setVehicleId] = useState('');
    const [vehicleDetails, setVehicleDetails] = useState([]);
    const [userByPhone, setUserByPhone] = useState('');

    const [customerPhone, setCustomerPhone] = useState('');
    const [customerCountryCode, setCustomerCountryCode] = useState('');

    const [rideDistance, setRideDistance] = useState(0);
    const [estimatedFare, setEstimatedFare] = useState(0);
    const [rideEta, setRideEta] = useState('');
    const [pickupAddress, setPickupAddress] = useState('');
    const [dropAddress, setDropAddress] = useState('');
    const [polyLine, setPolyLine] = useState('');
    const [isNearbyDrivers, setIsNearbyDrivers] = useState(false);
    const [vehicleType, setVehicleType] = useState('');
    const [pickupLocation, setPickupLocation] = useState('');
    const [pickupLatLng, setPickupLatLng] = useState(null);
    const [dropLocation, setDropLocation] = useState('');
    const [dropLatLng, setDropLatLng] = useState(null);
    const [stops, setStops] = useState([]);
    const [selectedStopIndex, setSelectedStopIndex] = useState(null);
    const [routePath, setRoutePath] = useState([]);
    const [directions, setDirections] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const currentstatus = "scheduledbooking";

    console.log(selectedRow,"selectedrow");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [pickupLocationData, setPickupLocationData] = useState([]);
    const [dropLocationData, setDropLocationData] = useState([]);
    const [openCancelBookingModal, setOpenCancelBookingModal] = useState(false);
    const [cancelBookingReason, setCancelBookingReason] = useState('');
    const [cancelBookingRow, setCancelBookingRow] = useState(null);
    const [userCodeSearch, setUserCodeSearch] = useState('');
    const [dateTime, setDateTime] = useState(dayjs());
    const [isBulkAssign, setIsBulkAssign] = useState(false);
    const [isToday, setIsToday] = useState(false);
    const [bulkDate, setBulkDate] = useState(dayjs());
    const [assignInProgress, setAssignInProgress] = useState(false);
    const [jobIdOnButtonClick, setJobIdOnButtonClick] = useState('');
    const [jobStatusOnButtonClick, setJobStatusOnButtonClick] = useState('');
    const [ongoingJobRidesData, setOngoingJobRidesData] = useState([]);
    const [rideIdUnderProcessModalOpen, setRideIdUnderProcessModalOpen] = useState(false);
    const [openJobStatusModal, setOpenJobStatusModal] = useState(false);
    const [openBulkFailedModal, setOpenBulkFailedModal] = useState(false);
    const [mainDriversData, setMainDriversData] = useState([]);
    const [openViewJobStatusModal, setOpenViewJobStatusModal] = useState(false);
    const [addClientModal, setAddClientModal] = useState(false);
    const [seatCount, setSeatCount] = useState('');
    const [additionalUserIds, setAdditionalUserIds] = useState([]);
    const map_search_zone = localStorage.getItem('map_search_zone');
    const [initialcityCenter, setInitialcityCenter] = useState();
    
    // State for custom autocomplete
    const [suggestions, setSuggestions] = useState([]);
    const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [activeInput, setActiveInput] = useState(null);
    const [debtLimit, setDebtLimit] = useState(cities[0].driver_debt_limit);
    
    const is_driver_debt_limit_enabled = localStorage.getItem('is_driver_debt_limit_enabled') || 0;
    const panel_customer_specific_address = localStorage.getItem('panel_customer_specific_address');
    const remove_add_stops = localStorage.getItem('remove_add_stops');
    const show_create_schedule_ride_button = localStorage.getItem('show_create_schedule_ride_button');
    const show_action_schedule_ride_column = localStorage.getItem('show_action_schedule_ride_column');
    const ride_event_logs_enabled = localStorage.getItem('ride_event_logs_enabled');
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');
    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';
    const add_pool_users = Number(localStorage.getItem('add_pool_users') || 0);
    const is_bulk_assign_enabled = Number(localStorage.getItem('is_bulk_assign_enabled') || 0);
    const clientId = localStorage.getItem('clientId');
    // Separate modal variables for Add Client (do not affect page inputs)
    const [modalSearchByClient, setModalSearchByClient] = useState(true);
    const [modalCustomerPhone, setModalCustomerPhone] = useState('');
    const [modalUserCodeSearch, setModalUserCodeSearch] = useState('');
    const [poolUsersData, setPoolUsersData] = useState([]);
    const [driverFilter, setDriverFilter] = useState('');
    const [selectedFareObj, setSelectedFareObj] = useState('');
    const [selectedridePickupDate,setSelectedridePickupDate] = useState('');
    const [camefromnavbar, setcamefromnavbar] = useState(false);
    // const [rideId, setRideId] = useState('');
    const [userStopMapping, setUserStopMapping] = useState({});
    const [startDateFilter, setStartDateFilter] = useState(selectedridePickupDate ? dayjs(selectedridePickupDate) : dayjs().startOf('month').startOf('day'));
    const [endDateFilter, setEndDateFilter] = useState(selectedridePickupDate ? dayjs(selectedridePickupDate) : dayjs().endOf('month').startOf('day'));
    const [customerIdFilter, setCustomerIdFilter] = useState('');
    const [clientIdFilter, setClientIdFilter] = useState('');
    const [customerNameFilter, setCustomerNameFilter] = useState('');
    const hide_fare_on_map_view_cancel = localStorage.getItem('hide_fare_on_map_view_cancel');


    const [searchByClient, setSearchByClient] = useState(clientId==188 ? true : false);
    const initialLoadRef = useRef(true);
    const prevFiltersRef = useRef({
        city: cityFilter,
        startDate: startDateFilter,
        endDate: endDateFilter,
        bulkDate: bulkDate,
        isBulkAssign: isBulkAssign
    });

    const [stopIds, setStopIds] = useState([{ 
        address: '', 
        latitude: '', 
        longitude: '', 
        stop_id: 1,
        locationId: ''  // Add this line
    }]);
    const [pickupDropLocationData, setPickupDropLocationData] = useState([]);
    const [modalUSerId, setModalUSerId] = useState('');
    const [modalUserName, setModalUserName] = useState('');
    const [modalPickupDropLocData, setModalPickupDropLocData] = useState([]);
    const [modalWayPoints, setModalWayPoints] = useState([]);
    const [flagFetchingStops, setFlagFetchingStops] = useState(false);
    const inputRef = useRef(null);   //pickup
    const inputDropRef = useRef(null);    //drop
    const stopRefs = useRef([]);    //refs for stop fields
    const country_code = localStorage.getItem('default_country_iso_code');
    const utc_offset_from_pickup_time = localStorage.getItem('utc_offset_from_pickup_time');
    const admin_id = Number(localStorage.getItem('admin_id'));

    const [openDetailsModal, setOpenDetailsModal] = useState(false);
        // const [selectedRow, setSelectedRow] = useState(null);
        const [steps,setSteps] = useState([]);
        const formatTime = (eventTime) => {
        if (!eventTime) return "";
    
        const date = new Date(eventTime);
    
        // Convert to pure UTC timestamp (remove browser auto conversion)
        const utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);
    
        // Now apply your custom utcOffset
        const adjustedDate = new Date(utcTime + utcOffset * 60000);
    
        return adjustedDate.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: timeZoneFormat === "12"
        });
        };
        const handleDetailsopen = (row) => {
            setSelectedRow(row);
            setSteps([]);
            setOpenDetailsModal(true);
            fetchRideLogData(row.ride_id);
        };
    
        const handleCloseDetailsModal = () => {
            setOpenDetailsModal(false);
            setSelectedRow(null);
        };
    
      const getEventTitle = (code) => {
        const map = {
          CUSTOMER_REQUEST_RIDE: "Ride Requested",
          NO_DRIVER_AVAILABLE: "No Driver Available",
          DRIVER_ACCEPTED: "Driver Accepted",
          DRIVER_ARRIVED: "Driver Arrived",
          TRIP_STARTED: "Trip Started",
          TRIP_ENDED: "Trip Ended",
          CUSTOMER_APP_CANCELLED: "Customer App",
          DRIVER_APP_CANCELLED: "Driver App",
          ADMIN_ASSIGN_DRIVER_TO_SCHEDULED_RIDE: "Admin assigned driver to scheduled ride",
          ADMIN_UNASSIGN_DRIVER_FROM_SCHEDULED_RIDE: "Admin unassigned driver from scheduled ride",
        };
    
        return map[code] || code.replaceAll("_", " ");
      };
    
      const getDescription = (log) => {
        switch (log.actor_type) {
          case "CUSTOMER":
            return `Customer (ID: ${log.actor_id} | Name: ${log.user_name}) initiated the ride request`;
          case "DRIVER":
            return `Driver (ID: ${log.actor_id} | Name: ${log.driver_name}) performed this action`;
          case "SYSTEM":
            return "System generated event";
          case "ADMIN":
            return `Admin (ID: ${log.actor_id} | Name: ${log.admin_name}) performed this action from admin panel`;
          default:
            return "";
        }
      };
    
      const sortedLogs = [...(steps || [])].sort(
        (a, b) => new Date(a.event_time) - new Date(b.event_time)
      );

        const fetchRideLogData = async (ride_id) => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();
    
                const url = serverUrl +`/customer/fetch_ride_event_logs`;
                const obj={
                    token: token,
                    ride_id: ride_id
                }
    
                const response =  await makeGetRequestToUrl(url, obj);
                if(response.flag == 200){
                    console.log('response = ', response);
                    setSteps(response?.data);
                }
    
                if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);
    
                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

    // Polling refs for job status
    const pollTimerRef = useRef(null);
    const latestStatusRef = useRef(null);
    const allColumns = [
        { id: 'ride_id', label: 'Ride ID' },
        { id: 'user_name', label: 'User' },
        { id: 'driver_name', label: 'Driver' },
        { id: 'user_code' , label: 'Client Id'},
        { id: 'engagement_id', label: 'Engagement Id' },
        { id: 'engagement_status', label: 'Engagement Status' },
        { id: 'pickup_time', label: 'Pickup Time' },
        { id: 'pickup_latitude', label: 'Pickup Latitude' },
        { id: 'pickup_longitude', label: 'Pickup Longitude' },
        { id: 'pickup_address', label: 'Pickup Address' },
        { id: 'drop_latitude', label: 'Drop Latitude' },
        { id: 'drop_longitude', label: 'Drop Longitude' },
        { id: 'drop_address', label: 'Drop Address' },
        { id: 'waypoints', label: 'Stops' },
        { id: 'status', label: 'Status' },
        { id: 'driver_arrival_time', label: 'Driver Arrival Time' },
        { id: 'vehicle_type', label: 'Vehicle Type' },
        { id: 'model_name', label: 'Vehicle Name' },
        { id: 'vehicle_number', label: 'Vehicle Number' },
        ...add_pool_users == 1 ? [{ id: 'pool_users', label: 'Pool Users' }] : [],
        { id: 'flight_number', label: 'Flight Number'},
        { id: 'passenger_count', label: 'Passenger Count' },
        { id: 'luggage_count', label: 'Luggage Count' },
        { id: 'payment_mode', label: 'Payment Mode' },
        { id: 'ride_distance', label: 'Ride Distance' },
        { id: 'estimated_fare', label: 'Ride Fare' },
        { id: 'promo_name', label: 'Promo Name' },
        { id: 'discount_amount', label: 'Discount Amount' },
        { id: 'cancellation_reason', label: 'Cancellation Reason' },
        { id: 'cancellation_time', label: 'Cancellation Time' },
        { id: 'created_at', label: 'Created At' },
        ...ride_event_logs_enabled == 1 ? [{ id: 'ride_details', label: 'Ride Details' }] : [],
        ...show_action_schedule_ride_column == 1 ? [{ id: 'action', label: 'Action' }] : [],
    ];

    // 1. Create a render function for each cell type
    const renderCellContent = (row, column) => {
        switch (column.id) {
            case 'ride_id':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.ride_id}</Typography>;
        
            case 'user_name':
                return (
            <Grid2 container sx={{ width: "auto", minWidth: "180px", alignItems: 'center', marginTop: '2%' }}>
                <Grid2>
                {row.user_image ? (
                    <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={row.user_image} />
                ) : (
                    <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile} />
                )}
                </Grid2>
                <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                <Typography sx={{ fontSize: '14px', textAlign: 'left', backgroundColor: '#FFFFFF', padding: '0px 2px', textDecoration: '#AC8312', borderRadius: "4px" }}>
                    <span style={{ color: '#9FA3A7' }}>User Id: </span>
                    <span style={{ color: '#AC8312' }}>{row?.user_id || '--'}</span>
                </Typography>
                <Typography sx={{ color: '#4E545D', fontSize: '16px' }}>{row.user_name || '--'}</Typography>
                <Typography sx={{ color: "#9FA3A7", fontSize: "12px" }}>{row.user_phone_number || '--'}</Typography>
                </Grid2>
            </Grid2>
            );
            
            case 'user_code':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.user_code || '--'}</Typography>;
            case 'driver_name':
                if (!row.driver_image && !row.driver_name && !row.driver_phone_number) {
                    return <Typography>--</Typography>;
                }
                return (
                    <Grid2 container sx={{ width: "auto", minWidth: "180px", alignItems: 'center', marginTop: '2%' }}>
                    <Grid2>
                        {row.driver_image ? (
                        <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={row.driver_image} />
                        ) : (
                        <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile} />
                        )}
                    </Grid2>
                    <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                        <Typography sx={{ 
                        fontSize: '14px', 
                        textAlign: 'left', 
                        backgroundColor: '#FFFFFF', 
                        padding: '0px 2px', 
                        textDecoration: '#AC8312', 
                        borderRadius: "4px" 
                        }}>
                        {row.driver_id && (
                            <>
                            <span style={{ color: '#9FA3A7' }}>Driver Id: </span>
                            <span style={{ color: '#AC8312' }}>{row.driver_id}</span>
                            </>
                        )}
                        </Typography>
                        {row.driver_name && (
                        <Typography sx={{ color: '#4E545D', fontSize: '16px' }}>{row.driver_name}</Typography>
                        )}
                        {row.driver_phone_number && (
                        <Typography sx={{ color: "#9FA3A7", fontSize: "12px" }}>{row.driver_phone_number}</Typography>
                        )}
                        {(is_driver_debt_limit_enabled==1 && row.driver_wallet_balance < debtLimit) && (
                            <Typography 
                                sx={{
                                    color: '#eb530daa', 
                                    // backgroundColor: '#ffebee',
                                    // padding: '2px 6px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    fontWeight: 'medium',
                                }}
                            >
                                (In Debt)
                            </Typography>
                        )}
                    </Grid2>
                    </Grid2>
                );
        
            case 'vehicle_type':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.vehicle_type==1 ? 'Taxi' : row.vehicle_type==2 ? 'Bike' : row.vehicle_type==3 ? 'Autos' : row.vehicle_type==4 ? 'Shuttle' : '--'}</Typography>;
    
            case 'status':
                const statusConfig = {
                1: { text: 'Unassigned', color: '#0065FF' },
                2: { text: 'In Progress', color: '#FFA500' },
                3: { text: 'Processed and Driver Assigned', color: '#0DBA78' },
                4: { text: 'Processed and no driver assigned', color: '#F5BB19' },
                5: { text: 'Cancelled By Customer', color: '#D14545' },
                6: { text: 'Ended', color: '#D14545'},
                7: { text: 'Customer No Show',color: '#ac7103' },
                8: { text: 'Cancelled By Admin', color: '#FFA500' },
                9: { text: 'Cancelled By System', color: '#FFA500' },
             };
                const status = statusConfig[row.status] || { text: '--', color: '#000' };
                return <Typography sx={{ color: status.color }}>{status.text}</Typography>;
    
            // Add more cases for other column types
            case 'engagement_status':
                const engagementConfig = {
                1: { text: 'Alive', color: '#808080' },
                2: { text: 'Accepted', color: '#0065FF' },
                3: { text: 'Arrived', color: '#F5BB19' },
                5: { text: 'Started', color: '#F5BB19' },
                6: { text: 'Ended', color: '#0DBA78' },
                7: { text: 'Rejected By Driver', color: '#D14545' },
                8: { text: 'Cancelled By Customer', color: '#FFA500' },
                9: { text: 'Cancelled By Driver', color: '#FFA500' },
                10: { text: 'Cancelled By Admin', color: '#FFA500' },
                11: { text: 'Reverse Bid Initiated By Driver', color: '#0DBA78' },
                12: { text: 'Rejected By Customer', color: '#FFA500' },
                13: { text: 'Customer No Show', color: '#ac7103' },
                14: { text: 'Cancelled By System', color: '#FFA500' },
                };
                const engagement = engagementConfig[row.engagement_status] || { text: '--', color: '#000' };
                return <Typography sx={{ color: engagement.color }}>{engagement.text}</Typography>;
            
            case 'model_name':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.model_name || '--'}</Typography>;

            case 'waypoints':
                return <Typography sx={{ width: 'auto', minWidth: '150px' }}>
                    <ul>
                    {row?.waypoints?.map((waypoint, index) => (
                        <li key={index}>{waypoint.address}</li>
                    )) || '--'}
                    </ul>
                    </Typography>;

            case 'created_at':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                    {row.created_at ? 
                        (() => {
                            const pickupDate = new Date(row.created_at);
                            // Add the offset minutes to the date
                            // var createdAtOffset = utcOffset - 330;
                            // pickupDate.setMinutes(pickupDate.getMinutes() + createdAtOffset);
                            pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                            return pickupDate.toLocaleString('en-GB', {
                            day: '2-digit', 
                            month: '2-digit', 
                            year: 'numeric', 
                            hour: '2-digit', 
                            minute: '2-digit', 
                            hour12: timeZoneFormat == '12' ? true : false,
                            timeZone: 'UTC'
                            }).replace(',', ' |');
                        })() 
                        : '--'
                    }
                </Typography>;
            case 'vehicle_number':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.vehicle_number || '--'}</Typography>;
            case 'action':
                if (show_action_schedule_ride_column != 1) return null;
                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {/* Assign Button - Show only for status 1 or 4 */}

                    {(row.status === 1 || row.status === 4) && (
                        <Button 
                        onClick={() => handleOpenAssignModal(row)}
                        sx={{
                            color: '#0065ff', 
                            border: '1px solid #0065ff', 
                            textTransform: 'none',
                            borderRadius: '8px', 
                            minWidth: '40px', 
                            boxShadow: 'none', 
                            width: "140px",
                            mb: 1,
                            '&:hover': { 
                            backgroundColor: '#0065ff', 
                            color: 'white' 
                            }
                        }}
                        >
                        <Typography>Assign driver</Typography>
                        </Button>
                    )}

                    {/* Reassign/Unassign Buttons - Show only when engagement_status is 2 */}
                    {row.engagement_status === 2 && (
                        <>
                        <Button 
                            onClick={() => handleOpenAssignModal(row, 'reassign')}
                            sx={{
                            color: '#0065ff', 
                            border: '1px solid #0065ff', 
                            textTransform: 'none',
                            borderRadius: '8px', 
                            minWidth: '40px', 
                            boxShadow: 'none', 
                            width: "140px",
                            mb: 1,
                            '&:hover': { 
                                backgroundColor: '#0065ff', 
                                color: 'white' 
                            }
                            }}
                        >
                            <Typography>Reassign driver</Typography>
                        </Button>

                        <Button 
                            onClick={() => handleOpenAssignModal(row, 'unassign')}
                            sx={{
                            color: '#0065ff', 
                            border: '1px solid #0065ff', 
                            textTransform: 'none',
                            borderRadius: '8px', 
                            minWidth: '40px', 
                            boxShadow: 'none', 
                            width: "140px",
                            mb: 1,
                            '&:hover': { 
                                backgroundColor: '#0065ff', 
                                color: 'white' 
                            }
                            }}
                        >
                            <Typography>Unassign driver</Typography>
                        </Button>
                        </>
                    )}

                    {/* Cancel Button - Show for all statuses except 5 */}
                    {(row.status == 1 || row.status == 3 || row.status == 4) && (
                        <Button 
                        onClick={() => handleCancelBooking(row)}
                        sx={{
                            color: '#D14545', 
                            border: '1px solid #D14545', 
                            textTransform: 'none',
                            borderRadius: '8px', 
                            minWidth: '40px', 
                            boxShadow: 'none', 
                            width: "140px",
                            '&:hover': { 
                            backgroundColor: '#D14545', 
                            color: 'white' 
                            }
                        }}
                        >
                        <Typography>Cancel</Typography>
                        </Button>
                    )}
                    </Box>
                );
            case 'payment_mode':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                   {constants.paymentMode[row.payment_mode || 1]} 
                </Typography>;
            case 'ride_distance':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.ride_distance || '--'}</Typography>;
            case 'estimated_fare':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.estimated_fare || '--'}</Typography>;
            case 'promo_name':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.promo_name || '--'}</Typography>;
            case 'discount_amount':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.discount_amount || '--'}</Typography>;
            case 'cancellation_reason':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.cancellation_reason || '--'}</Typography>;
            case 'cancellation_time':
                return utc_offset_from_pickup_time == 1 ? 
                <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.cancellation_time && convertUtcToLocal(row.pickup_latitude,row.pickup_longitude,row?.cancellation_time)?.localTime || '--'}</Typography> : 
                <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                    {(row.cancellation_time && row.cancellation_time!=null) ? 
                        (() => {
                            const pickupDate = new Date(row.cancellation_time);
                            // Add the offset minutes to the date
                            pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                            return pickupDate.toLocaleString('en-GB', {
                            day: '2-digit', 
                            month: '2-digit', 
                            year: 'numeric', 
                            hour: '2-digit', 
                            minute: '2-digit', 
                            hour12: timeZoneFormat == '12' ? true : false,
                            timeZone: 'UTC'
                            }).replace(',', ' |');
                        })() 
                        : '--'
                    }
                </Typography>;
            case 'pickup_time':
                return utc_offset_from_pickup_time == 1 ? 
                <Typography sx={{ width: 'auto', minWidth: '100px' }}>{convertUtcToLocal(row.pickup_latitude,row.pickup_longitude,row?.pickup_time)?.localTime || '--'}</Typography> : 
                <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                    {row.pickup_time ? 
                        (() => {
                            const pickupDate = new Date(row.pickup_time);
                            // Add the offset minutes to the date
                            pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                            return pickupDate.toLocaleString('en-GB', {
                            day: '2-digit', 
                            month: '2-digit', 
                            year: 'numeric', 
                            hour: '2-digit', 
                            minute: '2-digit', 
                            hour12: timeZoneFormat == '12' ? true : false,
                            timeZone: 'UTC'
                            }).replace(',', ' |');
                        })() 
                        : '--'
                    }
                </Typography>;

            case 'driver_arrival_time':
                if (!row?.driver_arrival_time) {
                    return <Typography sx={{ width: 'auto', minWidth: '100px' }}>--</Typography>;
                }
                return utc_offset_from_pickup_time == 1 ? 
                    <Typography sx={{ width: 'auto', minWidth: '100px' }}>{convertUtcToLocal(row.pickup_latitude,row.pickup_longitude,row?.driver_arrival_time)?.localTime || '--'}</Typography> : 
                    <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                        {row.driver_arrival_time ? 
                            (() => {
                                const pickupDate = new Date(row.driver_arrival_time);
                                pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                return pickupDate.toLocaleString('en-GB', {
                                day: '2-digit', 
                                month: '2-digit', 
                                year: 'numeric', 
                                hour: '2-digit', 
                                minute: '2-digit', 
                                hour12: timeZoneFormat == '12' ? true : false,
                                timeZone: 'UTC'
                                }).replace(',', ' |');
                            })() 
                            : '--'
                        }
                    </Typography>;
            case 'pickup_latitude':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.pickup_latitude || '--'}</Typography>;
            case 'pickup_longitude':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.pickup_longitude || '--'}</Typography>;
            case 'pickup_address':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.pickup_address || '--'}</Typography>;
            case 'drop_latitude':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.drop_latitude || '--'}</Typography>;
            case 'passenger_count':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.passenger_count || '--'}</Typography>;
            case 'flight_number':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.flight_number || '--'}</Typography>;
            case 'luggage_count':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.luggage_count || '--'}</Typography>;
            case 'drop_longitude':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.drop_longitude || '--'}</Typography>;
            case 'drop_address':
                return <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.drop_address || '--'}</Typography>;
            case 'pool_users': {
                const list = row?.pool_users;
                let text = '--';
                if (Array.isArray(list) && list.length) {
                    const ids = list
                        .map((u) => (u && typeof u === 'object' ? u.ride_id : u))
                        .filter((v) => v !== null && v !== undefined && v !== '')
                        .map(String);
                    text = ids.length ? ids.join(', ') : '--';
                } else if (typeof list === 'string' || typeof list === 'number') {
                    text = String(list);
                }
                return (
                    <Typography sx={{ fontSize: '14px', textAlign: 'left', padding: '0px 2px', textDecoration: '#AC8312', borderRadius: "4px" }}>
                        <span style={{ color: '#9FA3A7' }}>Ride Id: </span>
                        <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB'}}/>
                        <span style={{ color: '#AC8312' }}>{text}</span>
                    </Typography>
                );
            }
            case 'ride_details':
                if (ride_event_logs_enabled != 1) return null;
                return (
                    <Button
                        variant="contained"
                        onClick={() => handleDetailsopen(row)}
                        sx={{
                            backgroundColor: "white",
                            color: "#d9881eff",
                            border: "1px solid #d9881eff",
                            textTransform: "none",
                            borderRadius: "8px",
                            width: "auto", // Or set a specific width
                            minWidth: "120px",
                            marginBottom: "10px",
                            "&:hover": {
                            backgroundColor: "#fa8517ff",
                            color: "white",
                            },
                            "&:active": {
                            backgroundColor: "#f56a0dff",
                            color: "white",
                            },
                        }}
                        >
                            View Details
                    </Button>
                );

            default:
                return row[column.id] || '--';
        }
    };

    const handleModalSearchByClientToggle = (e) => {
        e.preventDefault();
        setModalUserCodeSearch('');
        setModalCustomerPhone('');
        setModalSearchByClient(!modalSearchByClient);
    }
  
    const handlerideIdChange = (e) => {
        const value = e.target.value;
        setNotificationRideId(value);

        setCustomerIdFilter('');
        setCustomerNameFilter('');
        setClientIdFilter('');
        
        const params = new URLSearchParams(window.location.search);
        if (value) {
            params.set('ride_id', value);
        } else {
            params.delete('ride_id');
        }
        navigate(`?${params.toString()}`, { replace: true });
    };

// Simplified handlers — just update state, nothing else
const handleCustomerIdChange = (e) => {
    const value = e.target.value;
    setCustomerIdFilter(value);
    if (value) {
        setNotificationRideId('');
        setCustomerNameFilter('');
        setClientIdFilter('');
        const params = new URLSearchParams(window.location.search);
        params.delete('ride_id');
        navigate(`?${params.toString()}`, { replace: true });
    }
};

const handleCustomerNameChange = (e) => {
    const value = e.target.value;
    setCustomerNameFilter(value);
    if (value) {
        setCustomerIdFilter('');
        setNotificationRideId('');
        const params = new URLSearchParams(window.location.search);
        params.delete('ride_id');
        navigate(`?${params.toString()}`, { replace: true });
    }
};

const handleClientIdChange = (e) => {
    const value = e.target.value;
    setClientIdFilter(value);
    if (value) {
        setNotificationRideId('');
        setCustomerNameFilter('');
        setCustomerIdFilter('');
    }
};

const handleStatusChange = (status) => {
    setStatusFilter(status);
    setPage(0);
};

const handleDriverFilterChange = (value) => {
    setDriverFilter(value);
    setPage(0);
};
        
    // Add this useEffect for initial load
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const rideIdFromUrl = params.get('ride_id');
        
        if (rideIdFromUrl) {
            setcamefromnavbar(true);
            setNotificationRideId(rideIdFromUrl);
        } else {
            setcamefromnavbar(false);
        }
    }, [location.search]); 

    
    // useEffect(() => {
    //     if (notificationRideId && rows && rows.length > 0) {
    //         let statusFiltered;
    //         if(isBulkAssign){
    //             statusFiltered = statusFilter == 10
    //                 ? rows.filter(row => row.status.toString() == '1' || row.status.toString() == '4')
    //                 : rows.filter(row => String(row.status) === String(statusFilter));
    //         }
    //         else{
    //             statusFiltered = rows;
    //         }

    //         const filteredData = statusFiltered.filter((item) => 
    //             item.ride_id && item.ride_id.toString().includes(notificationRideId)
    //         );
    //         setFilteredRows(filteredData);
    //         setPage(0);
            
    //         // If we came from navbar notification and found the ride
    //         if (camefromnavbar && filteredData.length > 0 && filteredData[0]?.pickup_time) {
    //             const pickupTime = filteredData[0].pickup_time;
    //             const formattedDate = dayjs(pickupTime).format('YYYY-MM-DD');
    //             setSelectedridePickupDate(formattedDate);
    //             // setStartDateFilter(dayjs(pickupTime));
    //             // setEndDateFilter(dayjs(pickupTime));
    //         }
    //     } else if (rows && rows.length > 0) {
    //         // setStartDateFilter(dayjs().startOf('month').startOf('day'));
    //         // setEndDateFilter(dayjs().endOf('month').endOf('day'));
    //         if(isBulkAssign){
    //             const filtered = statusFilter == 10
    //                     ? rows.filter(row => row.status.toString() == '1' || row.status.toString() == '4')
    //                     : rows.filter(row => String(row.status) === String(statusFilter));
    //             setFilteredRows(filtered);        
    //         }
    //         else{
    //             setFilteredRows(rows);
    //         }
    //     }
    // }, [notificationRideId, rows, navigate, location.pathname, camefromnavbar]);

    useEffect(() => {
        return () => {
            setSelectedridePickupDate(null);
            setcamefromnavbar(false);
        };
    }, []);
            
    // useEffect(() => {
    //     if (filteredRows.length > 0 && filteredRows[0]?.pickup_time) {
    // const pickupTime = filteredRows[0]?.pickup_time; // e.g., "2025-12-31 14:30:00"
    // if (pickupTime) {
    //     const formattedDate = dayjs(pickupTime).format('YYYY-MM-DD'); // "2025-12-31"
    //     setSelectedridePickupDate(formattedDate);
    // }
    //     }
    // }, [filteredRows]); 

    const getHiddenColumns = () => {
        const clientConfig = constants.clientColumnConfig[clientId] || constants.clientColumnConfig['default'];
        return clientConfig[currentstatus] || clientConfig['default'] || [];
    };
    
    const getVisibleColumns = () => {
        const hiddenColumns = getHiddenColumns();
        return allColumns.filter(column => !hiddenColumns.includes(column.id));
    };
    
    const [visibleColumns, setVisibleColumns] = useState(getVisibleColumns());
    useEffect(() => {
        setVisibleColumns(getVisibleColumns());
      }, [clientId, currentstatus]);


    const { isLoaded, loadError } = useGoogleMapsLoader();
    
    // Reference to Autocomplete Service
    const autocompleteService = useRef(null);
    const placesService = useRef(null);

    

    // Centralized filtering useEffect - respects all filters simultaneously
useEffect(() => {
    console.log('Filter effect running', { 
        rowsCount: rows.length, 
        clientIdFilter, 
        statusFilter 
    });
    if (!rows || rows.length === 0) {
        setFilteredRows([]);
        return;
    }

    let filteredData = [...rows];

    // 1. Status filter
    if (isBulkAssign) {
        if (statusFilter == '10') {
            filteredData = filteredData.filter(
                row => row.status?.toString() === '1' || row.status?.toString() === '4'
            );
        } else if (statusFilter !== '') {
            filteredData = filteredData.filter(
                row => String(row.status) === String(statusFilter)
            );
        }
    } else if (statusFilter !== '') {
        filteredData = filteredData.filter(
            row => String(row.status) === String(statusFilter)
        );
    }

    // 2. Ride ID filter (from URL / notification)
    if (notificationRideId) {
        filteredData = filteredData.filter(item =>
            item.ride_id && item.ride_id.toString().includes(notificationRideId)
        );
    }

    // 3. Customer ID filter
    if (customerIdFilter) {
        filteredData = filteredData.filter(item =>
            item.user_id && item.user_id.toString().includes(customerIdFilter)
        );
    }

    // 4. Customer name filter
    if (customerNameFilter) {
        filteredData = filteredData.filter(item =>
            item.user_name &&
            item.user_name.toString().toLowerCase().includes(customerNameFilter.toLowerCase())
        );
    }

    // 5. Client ID filter
    if (clientIdFilter) {
        filteredData = filteredData.filter(item =>
            item.user_code &&
            item.user_code.toString().toLowerCase().includes(clientIdFilter.toLowerCase())
        );
    }

    // 6. Driver filter
    if (driverFilter) {
        filteredData = filteredData.filter(
            row => String(row.driver_id ?? '') === String(driverFilter)
        );
    }

    setFilteredRows(filteredData);
    setPage(0);
    // Update selectedridePickupDate when filtering by ride ID finds a result
if (notificationRideId && filteredData.length > 0 && filteredData[0]?.pickup_time) {
    const formattedDate = dayjs(filteredData[0].pickup_time).format('YYYY-MM-DD');
    setSelectedridePickupDate(formattedDate);
}
}, [
    rows,
    statusFilter,
    notificationRideId,
    customerIdFilter,
    customerNameFilter,
    clientIdFilter,
    driverFilter,
    isBulkAssign
]);

    useEffect(() => {
        // Get booking_id from URL parameters
        const params = new URLSearchParams(window.location.search);
        const rideIdFromUrl = params.get('ride_id');
        
        if (rideIdFromUrl) {
            setNotificationRideId(rideIdFromUrl);
        }
    }, []);

    // Initialize Autocomplete Service
    useEffect(() => {
        if (isLoaded && window.google && window.google.maps && window.google.maps.places) {
            autocompleteService.current = new window.google.maps.places.AutocompleteService();
            // Create a dummy div for PlacesService (required by Google Maps API)
            const dummyDiv = document.createElement('div');
            placesService.current = new window.google.maps.places.PlacesService(dummyDiv);
        }
    }, [isLoaded]);

    // Handle input change for all fields (pickup, drop, stops)
    const handleInputChange = (e, field, index = null) => {
        const value = e.target.value;
        setActiveInput({ field, index });

        // Update the appropriate state
        if (field === 'pickup') {
            setPickupLocation(value);
        } else if (field === 'drop') {
            setDropLocation(value);
        } else if (field === 'stop') {
            const updatedStops = [...stops];
            if (updatedStops[index]) {
                updatedStops[index].location = value;
                setStops(updatedStops);
            }
        }

        // Fetch predictions if input length > 2
        if (value.length > 2 && autocompleteService.current) {
            autocompleteService.current.getPlacePredictions(
                { input: value,
                    ...(map_search_zone ? { componentRestrictions: { country: map_search_zone || 'IN' } } : {})
                 },
                (predictions, status) => {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
                        let combinedSuggestions = [...predictions];
                        
                        // Check if Calgary Airport is in the results
                        const isAirport = predictions.some(p => p.place_id === CALGARY_AIRPORT_PLACE_ID);
                        
                        if (isAirport) {
                            // Add custom terminals to the beginning of the array
                            combinedSuggestions = [...AIRPORT_TERMINALS, ...predictions];
                        }
                        
                        setSuggestions(combinedSuggestions);
                        setShowSuggestions(true);
                        setActiveSuggestionIndex(0);
                    } else {
                        setSuggestions([]);
                        setShowSuggestions(false);
                    }
                }
            );
        } else {
            setSuggestions([]);
            setShowSuggestions(false);
        }
    };

    // Handle suggestion click
    const handleSuggestionClick = (suggestion) => {
        if (!suggestion) return;

        const { place_id, description, title } = suggestion;
        
        console.log('Suggestion clicked:', { place_id, description, suggestion, title });

        // Check if this is a custom terminal (has latitude/longitude directly)
        if (suggestion.latitude && suggestion.longitude) {
            // Handle custom terminal selection
            console.log('Custom terminal selected:', description);
            if (activeInput.field === 'pickup') {
                setPickupLocation(description);
                setPickupAddress(title || description); // Also set pickupAddress
                setPickupLatLng({ lat: suggestion.latitude, lng: suggestion.longitude });
                setVehicleId('');
                setVehicleType('');
            } else if (activeInput.field === 'drop') {
                setDropLocation(description);
                setDropAddress(title || description); // Also set dropAddress
                setDropLatLng({ lat: suggestion.latitude, lng: suggestion.longitude });
                setVehicleId('');
                setVehicleType('');
            } else if (activeInput.field === 'stop') {
                const updatedStops = [...stops];
                if (updatedStops[activeInput.index]) {
                    updatedStops[activeInput.index] = {
                        ...updatedStops[activeInput.index],
                        location: description,
                        address: title || description,
                        latitude: suggestion.latitude,
                        longitude: suggestion.longitude,
                    };
                    setStops(updatedStops);
                    setVehicleId('');
                    setVehicleType('');
                    setTimeout(() => updatePolylineWithStops(), 0);
                }
            }
            setShowSuggestions(false);
            return;
        }

        // For regular Google Places predictions, get details using place_id
        console.log('Regular Google Place selected, fetching details for:', description);
        if (placesService.current) {
            placesService.current.getDetails(
                { placeId: place_id, fields: ['geometry', 'formatted_address', 'address_components'] },
                (place, status) => {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
                        const lat = place.geometry.location.lat();
                        const lng = place.geometry.location.lng();
                        
                        console.log('Place details received:', { 
                            description, 
                            formatted_address: place.formatted_address,
                            lat, 
                            lng,
                            field: activeInput.field 
                        });

                        if (activeInput.field === 'pickup') {
                            // Use description from the suggestion, not formatted_address
                            console.log('Setting pickup location to:', description);
                            setPickupLocation(description);
                            setPickupAddress(title || description); // Also set pickupAddress to prevent Directions API from overwriting
                            setPickupLatLng({ lat, lng });
                            setVehicleId('');
                            setVehicleType('');
                        } else if (activeInput.field === 'drop') {
                            // Use description from the suggestion, not formatted_address
                            console.log('Setting drop location to:', description);
                            setDropLocation(description);
                            setDropAddress(title || description); // Also set dropAddress to prevent Directions API from overwriting
                            setDropLatLng({ lat, lng });
                            setVehicleId('');
                            setVehicleType('');
                        } else if (activeInput.field === 'stop') {
                            console.log('Setting stop location to:', description);
                            const updatedStops = [...stops];
                            if (updatedStops[activeInput.index]) {
                                updatedStops[activeInput.index] = {
                                    ...updatedStops[activeInput.index],
                                    location: description,
                                    address: title || description,
                                    latitude: lat,
                                    longitude: lng,
                                };
                                setStops(updatedStops);
                                setVehicleId('');
                                setVehicleType('');
                                setTimeout(() => updatePolylineWithStops(), 0);
                            }
                        }
                    }
                }
            );
        }

        setShowSuggestions(false);
    };

    // Function to update polyline with all points (pickup, stops or stopIds, drop)
    const updatePolylineWithStops = () => {
        // Check if we have at least a pickup location
        if (!pickupLatLng) return;
        
        // Prefer stopIds-based stops (panel saved addresses) if available; otherwise use free-typed stops[]
        let validStops = [];
        if (stopIds && stopIds.length > 0) {
            validStops = stopIds
                .map((s) => {
                    const m = pickupDropLocationData.find(loc => loc.id === s.locationId);
                    if (m && m.latitude && m.longitude) {
                        return {
                            stop_id: s.stop_id,
                            latitude: parseFloat(m.latitude),
                            longitude: parseFloat(m.longitude)
                        };
                    }
                    // fallback to any lat/lng already stored on stopIds
                    if (s.latitude && s.longitude) {
                        return {
                            stop_id: s.stop_id,
                            latitude: parseFloat(s.latitude),
                            longitude: parseFloat(s.longitude)
                        };
                    }
                    return null;
                })
                .filter(Boolean);
        }
        if (validStops.length === 0) {
            // fallback to manual stops[] when stopIds is empty or invalid
            validStops = stops.filter(stop => stop.latitude && stop.longitude);
        }
        
        // Sort the stops by their stop_id to ensure sequential order
        const sortedStops = [...validStops].sort((a, b) => a.stop_id - b.stop_id);
        
        // If no pickup and no valid stops, nothing to do
        if (sortedStops.length === 0 && !dropLatLng) {
            return;
        }
        
        // If only pickup and drop (no stops), use simple directions
        if (sortedStops.length === 0 && dropLatLng) {
            fetchDirections();
            return;
        }
        
        // Create waypoints for all stops in the correct order
        const waypoints = sortedStops.map(stop => ({
            location: new window.google.maps.LatLng(stop.latitude, stop.longitude),
            stopover: true // Ensures the route actually passes through this point
        }));
        
        const directionsService = new window.google.maps.DirectionsService();
        
        // Always use drop location as destination when available
        const destination = dropLatLng 
            ? new window.google.maps.LatLng(dropLatLng.lat, dropLatLng.lng)
            : new window.google.maps.LatLng(sortedStops[sortedStops.length - 1].latitude, sortedStops[sortedStops.length - 1].longitude);
        
        // If we're using the last stop as destination, remove it from waypoints to avoid duplicating it
        const adjustedWaypoints = dropLatLng ? waypoints : waypoints.slice(0, -1);
        
        // Log the sequence to verify the order
        console.log('Route sequence:', {
            origin: 'Pickup',
            waypoints: adjustedWaypoints.map((wp, i) => `Stop ${i+1}`),
            destination: dropLatLng ? 'Drop' : `Stop ${sortedStops.length}`
        });
        
        const request = {
            origin: new window.google.maps.LatLng(pickupLatLng.lat, pickupLatLng.lng),
            destination: destination,
            waypoints: adjustedWaypoints,
            optimizeWaypoints: false, // Keep the order of stops exactly as specified
            travelMode: window.google.maps.TravelMode.DRIVING,
            provideRouteAlternatives: false,
            avoidHighways: false,
            avoidTolls: false
        };
        
        directionsService.route(request, (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
                setPolyLine(result.routes[0].overview_polyline);
                
                // Sum up distance from all legs
                let totalDistance = 0;
                let totalDuration = 0;
                
                // Extract the path points from all legs to create a single path
                const path = [];
                
                result.routes[0].legs.forEach(leg => {
                    totalDistance += leg.distance.value;
                    totalDuration += (leg.duration.value)/60;
                    
                    // Add all steps' points to our path
                    leg.steps.forEach(step => {
                        // Decode the path points from each step
                        const pathPoints = window.google.maps.geometry.encoding.decodePath(
                            step.polyline.points
                        );
                        
                        // Add each point to our path array (but skip first point after the first step
                        // to avoid duplicates where steps connect)
                        pathPoints.forEach((point, idx) => {
                            if (idx > 0 || path.length === 0) {
                                path.push({ lat: point.lat(), lng: point.lng() });
                            }
                        });
                    });
                });
                
                // Set the complete path for our single polyline
                setRoutePath(path);
                
                setRideDistance(totalDistance);
                setRideEta(totalDuration);
                // Don't overwrite addresses if they were already set by Places API
                // setPickupAddress(result.routes[0].legs[0].start_address);
                // setDropAddress(result.routes[0].legs[result.routes[0].legs.length - 1].end_address);
                setDirections(result);
            } else {
                console.error("Directions request failed due to " + status);
            }
        });
    };

    const fetchDirections = () => {
        if (pickupLatLng && dropLatLng) {
            const directionsService = new window.google.maps.DirectionsService();
            const request = {
                origin: pickupLatLng,
                destination: dropLatLng,
                travelMode: window.google.maps.TravelMode.DRIVING, // or WALKING, BICYCLING, etc.
            };
            directionsService.route(request, (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    setPolyLine(result.routes[0].overview_polyline);
                    setRideDistance(result.routes[0].legs[0].distance.value);
                    // Don't overwrite addresses if they were already set by Places API
                    // setPickupAddress(result.routes[0].legs[0].start_address);
                    // setDropAddress(result.routes[0].legs[0].end_address);
                    setRideEta((result.routes[0].legs[0].duration.value)/60);
                    // Extract the path points for our single polyline
                    const path = [];
                    result.routes[0].legs[0].steps.forEach(step => {
                        // Decode the path points
                        const points = window.google.maps.geometry.encoding.decodePath(
                            step.polyline.points
                        );
                        
                        // Add each point to our path array
                        points.forEach((point, idx) => {
                            if (idx > 0 || path.length === 0) {
                                path.push({ lat: point.lat(), lng: point.lng() });
                            }
                        });
                    });
                    
                    // Set the path for our single polyline
                    setRoutePath(path);
                    setDirections(result);
                } else {
                    console.error("Directions request failed due to " + status);
                }
            });
        }
    };

    // Add a specific useEffect to handle direction fetching
    useEffect(() => {
        if (pickupLatLng && dropLatLng) {
            // Check if we have manual stops
            const validStops = stops.filter(stop => stop.latitude && stop.longitude);
            if (validStops.length > 0) {
                updatePolylineWithStops();
            } else {
                fetchDirections();
            }
        }
    }, [pickupLatLng, dropLatLng]);

    // Recompute route whenever stopIds change to draw polyline through the selected stops
    useEffect(() => {
        // If pickup is selected and at least one stopId has coordinates or a resolvable locationId
        const hasResolvableStops = stopIds && stopIds.some(s => {
            if (s.latitude && s.longitude) return true;
            const m = pickupDropLocationData.find(loc => loc.id === s.locationId);
            return !!(m && m.latitude && m.longitude);
        });

        if (pickupLatLng && hasResolvableStops) {
            // This will handle both cases: with or without dropLatLng
            updatePolylineWithStops();
        }
    }, [stopIds, pickupLatLng, dropLatLng, pickupDropLocationData]);

    // Recompute route when manual stops[] change (used when panel_customer_specific_address != 1)
    useEffect(() => {
        if (!pickupLatLng) return;
        const validManualStops = stops && stops.filter(s => s.latitude && s.longitude);
        if (validManualStops.length > 0) {
            updatePolylineWithStops();
        } else if (dropLatLng) {
            // No manual stops, but we have pickup+drop
            fetchDirections();
        }
    }, [stops, pickupLatLng, dropLatLng]);

    const [map, setMap] = useState(null)
    // Convert containerStyle to state so it can be changed when Fetch Details is clicked
    const [containerStyle, setContainerStyle] = useState({
        width: '100%',
        height: '500px',
    });
    const center = {
        // lat: 28.644800, lng: 77.216721
        lat: pickupLatLng ? pickupLatLng.lat : 28.644800, 
        lng: pickupLatLng ? pickupLatLng.lng : 77.216721
    };

    useEffect(()=>{
        const citycenter = cities.find((cityObj) => cityObj.city_id === cityFilter);
        if (citycenter?.center_latitude && citycenter?.center_longitude) {
            const geocenter = {
                lat: Number(citycenter?.center_latitude),
                lng: Number(citycenter?.center_longitude)
            };
            setInitialcityCenter(geocenter);
        }
    },[cityFilter])
    
    const onLoad = React.useCallback((map) => {
        setMap(map); // Store the map instance
    }, []);

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);
    
    // Create a direct polyline between pickup and drop when both are selected from dropdown
    useEffect(() => {
        // Only proceed if both coordinates are properly defined and valid
        if (pickupLatLng && dropLatLng && 
            typeof pickupLatLng.lat === 'number' && !isNaN(pickupLatLng.lat) &&
            typeof pickupLatLng.lng === 'number' && !isNaN(pickupLatLng.lng) &&
            typeof dropLatLng.lat === 'number' && !isNaN(dropLatLng.lat) &&
            typeof dropLatLng.lng === 'number' && !isNaN(dropLatLng.lng)) {
                
            if (map) {
                try {
                    // Calculate the midpoint between pickup and drop
                    const bounds = new window.google.maps.LatLngBounds();
                    bounds.extend(new window.google.maps.LatLng(pickupLatLng.lat, pickupLatLng.lng));
                    bounds.extend(new window.google.maps.LatLng(dropLatLng.lat, dropLatLng.lng));
                    
                    // Fit the map to these bounds with some padding
                    map.fitBounds(bounds, { padding: 50 });
                } catch (error) {
                    console.error('Error setting map bounds:', error);
                }
            }
        }
    }, [pickupLatLng, dropLatLng, map]);
    
    const getNextStopId = () => {
        // Current stops length + 1 will give us 1, 2, 3 for the sequence
        return stops.length + 1;
    };
    
    // Handler for adding a new stop
    const handleAddStop = () => {
        if(stops.length >= 3){
            setMessage('Maximum 3 stops are allowed');
            showSnackbar(true);
            return;
        }
        // Assign a unique stop_id when creating the stop
        setStops([...stops, { 
            address: '', 
            latitude: '', 
            longitude: '', 
            stop_id: getNextStopId(),
            // display_index: stops.length + 1 // For UI display purposes
        }]);
    };
    
    // Handler for updating a stop's location
    const handleStopLocationChange = (index, value) => {
        const updatedStops = [...stops];
        updatedStops[index].address = value;
        setStops(updatedStops);
        setVehicleId('');
        setVehicleType('');
    };

    // Handler for selecting a stop in the textfield
    const handleStopFocus = (index) => {
        setSelectedStopIndex(index);
    };
    const handleRemoveStop = (indexToRemove) => {
        
        // Use functional update to ensure we're working with the latest state
        setStops(currentStops => {
            // Make a clean copy of the stops array without the removed stop
            const updatedStops = currentStops
                .filter((_, index) => index !== indexToRemove)
                .map((stop, i) => ({
                    ...stop,
                    stop_id: i + 1,
                }));
            
            // Reset vehicle selection whenever stops change
            setVehicleId('');
            setVehicleType('');
            
            // Schedule polyline update if needed
            setTimeout(() => {
                if (pickupLatLng && dropLatLng && updatedStops.some(stop => stop.latitude && stop.longitude)) {
                    updatePolylineWithStops();
                } else if (pickupLatLng && dropLatLng) {
                    fetchDirections();
                }
            }, 100);
            
            return updatedStops;
        });
    };

    const fetchAddress = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/customer/fetch_specific_address';
            const timestamp = new Date().getTime();
            const body1 = {
                token: token,
                user_id: userByPhone.user_id,
                address_type: 1,
                timestamp: timestamp
            };
            const body2 = {
                token: token,
                user_id: userByPhone.user_id,
                address_type: 2,
                timestamp: timestamp
            }
            const response =  await makeGetRequestToUrl(url, body1);
            const response2 = await makeGetRequestToUrl(url, body2);
            let both = [];
            if(response.flag==200){
                setPickupLocationData(response.data);
                both.push(...response.data)
            }
            if(response2.flag==200){
                setDropLocationData(response2.data);
                both.push(...response2.data)
            }
            setPickupDropLocationData(both);
            if(response.flag==102 || response2.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        if(userByPhone?.user_id)
        fetchAddress();
    },[userByPhone])

    useEffect(() => {
        if(modalUSerId){
            console.log('modalUSerId', modalUSerId);
            fetchModalAddress();
        }
    },[modalUSerId])

    const fetchModalAddress = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/customer/fetch_specific_address';
            const timestamp = new Date().getTime();
            const body1 = {
                token: token,
                user_id: modalUSerId,
                address_type: 1,
                timestamp: timestamp
            };
            const body2 = {
                token: token,
                user_id: modalUSerId,
                address_type: 2,
                timestamp: timestamp
            }
            const response =  await makeGetRequestToUrl(url, body1);
            const response2 = await makeGetRequestToUrl(url, body2);
            let both = [];
            if(response.flag==200){
                // setPickupLocationData(response.data);
                both.push(...response.data)
            }
            if(response2.flag==200){
                // setDropLocationData(response2.data);
                both.push(...response2.data)
            }
            console.log('both', both);
            setModalPickupDropLocData(both);

            if(response.flag==102 || response2.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
        
    const handleCityChange = (e) => {
        const city = cities.find((cityObj) => cityObj.city_id === e);
        setCityFilter(city.city_id);
        setDebtLimit(city.driver_debt_limit);
    };

    const fetchScheduledBookings = async(signal) => {
        try {
            const url = serverUrl + '/panel/fetch_scheduled_ride';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                start_date: isBulkAssign ? bulkDate.format('YYYY-MM-DD') : startDateFilter.format('YYYY-MM-DD'),
                end_date: isBulkAssign ? bulkDate.format('YYYY-MM-DD') : endDateFilter.format('YYYY-MM-DD'),
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body , {signal});
            if (response.flag == 200) {
                const sortedData = [...response.data].sort((a, b) => {
                    const aTime = new Date(a.pickup_time);
                    const bTime = new Date(b.pickup_time);
                    return aTime - bTime; // 🔁 Ascending
                });
                if(isBulkAssign){
                    setRows(sortedData);
                    const filtered = statusFilter == 10
                        ? sortedData.filter(row => row.status.toString() == '1' || row.status.toString() == '4')
                        : sortedData.filter(row => String(row.status) === String(statusFilter));
                    // setFilteredRows(filtered);
                }
                else{
                    setRows(sortedData);
                    // Apply status filter first
                    let base = statusFilter != ''
                        ? sortedData.filter(row => String(row.status) === String(statusFilter))
                        : sortedData;
                    // Then apply driver filter if set
                    if (driverFilter) {
                        base = base.filter(row => String(row.driver_id ?? '') === String(driverFilter));
                    }
                    // setFilteredRows(base);
                }
                
                // setStatusFilter('');
                setOrder('asc');          // ✅ reflects ascending order
                setOrderBy('pickup_time'); // ✅ reflects correct column
            }  
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                await fetchScheduledBookings(signal);
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error('Error fetching scheduled bookings:', error);
                }
            }
        };

        const hasFilterChanged = 
            cityFilter !== prevFiltersRef.current.city ||
            !startDateFilter.isSame(prevFiltersRef.current.startDate, 'day') ||
            !endDateFilter.isSame(prevFiltersRef.current.endDate, 'day') ||
            (bulkDate && !bulkDate.isSame(prevFiltersRef.current.bulkDate, 'day')) ||
            isBulkAssign !== prevFiltersRef.current.isBulkAssign;

        if (initialLoadRef.current || hasFilterChanged) {
            fetchData();
            initialLoadRef.current = false;
            prevFiltersRef.current = {
                city: cityFilter,
                startDate: startDateFilter,
                endDate: endDateFilter,
                bulkDate: bulkDate,
                isBulkAssign: isBulkAssign
            };
        }

        return () => {
            isMounted = false;
            controller.abort();
        };
    }, [cityFilter, startDateFilter, endDateFilter, bulkDate, isBulkAssign]);

    useEffect(() => {
        if(!isBulkAssign && is_bulk_assign_enabled>0){
            getOngoingRideIds();
        }
    }, [isBulkAssign]);

    const prevCityRef = useRef(cityFilter);
    const prevStartRef = useRef(startDateFilter);
    const prevEndRef = useRef(endDateFilter);

    useEffect(() => {
        const cityChanged = cityFilter !== prevCityRef.current;
        const startChanged = !startDateFilter.isSame(prevStartRef.current, 'day');
        const endChanged = endDateFilter && prevEndRef.current 
            ? !endDateFilter.isSame(prevEndRef.current, 'day') 
            : false;

        // Only reset filters when date/city actually changes AFTER initial mount
        if (!initialLoadRef.current && (cityChanged || startChanged || endChanged)) {
            setStatusFilter('');
            setDriverFilter('');
            setCustomerIdFilter('');
            setCustomerNameFilter('');
            setClientIdFilter('');
            setNotificationRideId('');
        }

        prevCityRef.current = cityFilter;
        prevStartRef.current = startDateFilter;
        prevEndRef.current = endDateFilter;
    }, [startDateFilter, endDateFilter, cityFilter]);

    // const handleRequestSort = (property) => {
    //     const isAscending = orderBy === property && order === 'asc';
    //     setOrder(isAscending ? 'desc' : 'asc');
    //     setOrderBy(property);
        
    //     // Sort the main rows array
    //     const sortedRows = [...rows].sort((a, b) => {
    //         if (a[property] < b[property]) return isAscending ? -1 : 1;
    //         if (a[property] > b[property]) return isAscending ? 1 : -1;
    //         return 0;
    //     });
    //     setRows(sortedRows);
        
    //     // Sort the filtered rows array as well
    //     const sortedFilteredRows = [...filteredRows].sort((a, b) => {
    //         if (a[property] < b[property]) return isAscending ? -1 : 1;
    //         if (a[property] > b[property]) return isAscending ? 1 : -1;
    //         return 0;
    //     });
    //     setFilteredRows(sortedFilteredRows);
    // };

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        const newOrder = isAscending ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
    
        const parseValue = (val) => {
            if (val == null) return null;
    
            // Try parsing date
            const date = new Date(val);
            if (!isNaN(date.getTime())) return date;
    
            // Only treat as number if it's purely numeric
            if (/^\d+(\.\d+)?$/.test(val)) {
                return parseFloat(val);
            }
    
            // Otherwise keep as lowercase string (handles alphanumerics correctly)
            return val.toString().toLowerCase();
        };
    
        const compare = (a, b) => {
            const aVal = parseValue(a[property]);
            const bVal = parseValue(b[property]);
    
            if (aVal == null && bVal == null) return 0;
            if (aVal == null) return newOrder === 'asc' ? -1 : 1;
            if (bVal == null) return newOrder === 'asc' ? 1 : -1;
    
            if (aVal < bVal) return newOrder === 'asc' ? -1 : 1;
            if (aVal > bVal) return newOrder === 'asc' ? 1 : -1;
            return 0;
        };
    
        // setRows([...rows].sort(compare));
        setFilteredRows([...filteredRows].sort(compare));
    };
       

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // const handleStatusChange = (status) => {
    //     console.log('status', status);
    //     setStatusFilter(status);
    //     let base = rows;
    //     // Apply status filter first
    //     if (status === '') {
    //         base = rows;
    //     } else if (status == '10') {
    //         base = rows.filter(row => row.status?.toString() === '1' || row.status?.toString() === '4');
    //     } else {
    //         base = rows.filter(row => row.status?.toString() == status);
    //     }
    //     // Then apply driver filter if set
    //     if (driverFilter) {
    //         base = base.filter(row => String(row.driver_id ?? '') === String(driverFilter));
    //     }
    //     setFilteredRows(base);
    //     setPage(0);
    // };

    // const handleDriverFilterChange = (value) => {
    //     setDriverFilter(value);
    //     let base = rows;
    //     // Respect current status filter
    //     if (statusFilter === '') {
    //         base = rows;
    //     } else if (statusFilter == '10') {
    //         base = rows.filter(row => row.status?.toString() === '1' || row.status?.toString() === '4');
    //     } else {
    //         base = rows.filter(row => row.status?.toString() == statusFilter);
    //     }
    //     // Apply driver filter
    //     if (value) {
    //         base = base.filter(row => String(row.driver_id ?? '') === String(value));
    //     }
    //     setFilteredRows(base);
    //     setPage(0);
    // };

    const fetchCityDrivers = async (client_vehicle_id, ride_id) => {
        try{
            setAssigningDrivers(true);
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            // const url = `${serverUrl}/driver/fetch_city_driver`;
            const url = serverUrl + "/driver/city_online_driver"
            const obj={
                token: token, 
                timestamp: timestamp,
                city_id: cityFilter,
                scheduled_id: ride_id,
                client_vehicle_id: client_vehicle_id
            }
            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==411){
                setNoDriverMessage(response.message);
            }

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const cityDriversData = response.data;
                setDriversData(cityDriversData);
                setNoDriverMessage('');
            }
            else {
                throw new Error(`HTTP error! Message: ${response.message}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
        finally{
            setAssigningDrivers(false);
        }
    };

    const handleOpenAssignModal = (row, type) => {
        if(is_bulk_assign_enabled>0) getOngoingRideIds();
        if(checkOngoingBulkRideId(row.ride_id)){
            setRideIdUnderProcessModalOpen(true);
            return;
        }
        else{
            console.log('You are allowed to assign driver to this ride');
            
            if(type=='unassign'){
                setIsUnassign(true);
                // setOpenAssignModal(true);
                setOpenUnassign(true);
                setIsReassign(false);
                setEngagementId(row.engagement_id);
            }
            else{
                setOpenAssignModal(true);
            }
            fetchCityDrivers(row.client_vehicle_id, row.ride_id);
            setRideId(row.ride_id);
            setPoolUsersData(row?.pool_users);
            if(type=='reassign'){
                setIsReassign(true);
                setIsUnassign(false);
                setEngagementId(row.engagement_id);
            }
            setDriverId(row.driver_id);
            setAssignDriver({driver_id: '', shift_id: '', shift_vehicle_id: ''});
        }
        setSelectedRow(row);
    }

    const handleClose = () => {
        setOpenAssignModal(false);
        setIsReassign(false);
        setEngagementId('');
        setIsUnassign(false);
        setAssignDriver({driver_id: '', shift_id: '', shift_vehicle_id: ''});
        setDriversData([]);
        setDriverId('');
        // setSelectedRow(null);
    }

    const handleSubmit = async () => {
        if (isSubmitting) return;
        console.log('assign===', assignDriver);
        setIsSubmitting(true);
        try {
            const token = localStorage.getItem('token');
            const payload = {
                token: token,
                driver_id: assignDriver.driver_id ? assignDriver.driver_id : driverId,
                scheduled_ride_id: rideId,
            };
            if(isReassign){
                payload['is_reassign'] = 1;
                payload['engagement_id'] = engagementId;
            }
            if(isUnassign){
                payload['is_unassign'] = 1;
                payload['engagement_id'] = engagementId;
            }
            if(!isUnassign){
                if(assignDriver.shift_id && assignDriver.shift_id!=0) payload['driver_shift_id'] = assignDriver.shift_id;
                if(assignDriver.shift_vehicle_id && assignDriver.shift_vehicle_id!=0) payload['vehicle_make_id'] = assignDriver.shift_vehicle_id;
            }
    
            let url = operationsUrl + '/admin-panel/assign_scheduled_ride';
    
            const response = await makePostRequestToUrl(url, payload);
    
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                fetchScheduledBookings();
                setStatusFilter('');
                setDriverFilter('');
            } else {
                setMessage(response.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.error(`Error`, error);
            setMessage(`An error occurred`);
            showSnackbar(true);
        } finally {
            setIsSubmitting(false);
            handleClose();
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleOpenAddBooking = () =>{
        setOpenAddModal(true);
        setCustomerPhone('');
        setUserCodeSearch('');
        setPickupLocation('');
        setDropLocation('');
        setPickupLatLng(null);
        setDropLatLng(null);
        setPolyLine('');
        setRideDistance(0);
        setRideEta(0);
        setUserByPhone(null);
        setVehicleType('');
        setVehicleId('');
        setEstimatedFare(0);
        setDateTime(dayjs());
        setStops([]);
        setSeatCount('');
        setAdditionalUserIds([]);
        setRoutePath([]);
        setDriversData([]);
        setModalWayPoints([]);
    }

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
    }

    const searchDriverByPhone = async() =>{
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = serverUrl + "/customer/user_by_phone_no"
            const obj={
                token: token, 
                timestamp: timestamp,
                // phone_number: customerPhone,
                // client_id: localStorage.getItem('clientId')
            }
            if(searchByClient){
                obj['user_code'] = userCodeSearch;
            }else{
                obj['phone_number'] = customerPhone;
            }
            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const userbyPhone = response.data.user_details;
                setUserByPhone(userbyPhone);
                setMessage(response.message);
                showSnackbar(false);
            }
            else {
                setMessage(response.message);
                showSnackbar(true);
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const searchByPhone = () =>{
        setContainerStyle({
            width: '100%',
            height: '350px',  // Reduce the height when user details are fetched
        });
        setStopIds([]);
        searchDriverByPhone();
    }


    const fetchDataByVehicleType = async() => {
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/find_nearby_drivers`;
            const body={
                token: token, 
                // timestamp: timestamp, 
                is_panel_request:1, 
                ride_distance: rideDistance/1000,
                ride_eta: Math.round(rideEta),
                pickup_latitude: String(pickupLatLng.lat),
                pickup_longitude: String(pickupLatLng.lng),
                drop_latitude: String(dropLatLng.lat),
                drop_longitude: String(dropLatLng.lng),
                encoded_polyline: String(polyLine),
                city_id: cityFilter
            }

            const response =  await makePostRequestToUrl(url, body);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const vehicleDetails = response.data.vehicle_details;
                const driversData = [];
                setVehicleDetails(vehicleDetails);
                for(var i=0;i<vehicleDetails.length;i++){
                    if(vehicleDetails[i].vehicle_id == vehicleId){
                        for(var j=0;j<vehicleDetails[i].active_driver.length;j++){
                            driversData.push(vehicleDetails[i].active_driver[j]);
                        }
                        setEstimatedFare(vehicleDetails[i].estimated_fare);
                        setSeatCount(vehicleDetails[i].seat_count);
                    }
                }
                setDriversData(driversData);
                setIsNearbyDrivers(true);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(()=>{
        if(vehicleType!='' && vehicleId!=''){
            fetchDataByVehicleType();
            fetchMainCityDrivers();
            setAssignDriver({
                driver_id: '',
                driver_name: '',
                driver_phone_number: '',
                shift_id: '',
                shift_vehicle_id: '',
            });
        }
        
    }, [vehicleType, vehicleId]);

    useEffect(()=>{
        if(vehicleType!='' && vehicleId!='')
        fetchMainCityDrivers();
    }, [dateTime]);

    const handleChange = (vehicleId) => {
        const selectedVehicle = vehicleDetails.find(v => v.vehicle_id === vehicleId);  // Find the selected vehicle based on vehicle_id
        if (selectedVehicle) {
            setVehicleType(selectedVehicle.vehicle_type);  // Set vehicle_type state
            setVehicleId(vehicleId);  // Set vehicle_id state
            setSelectedFareObj(selectedVehicle.fare_obj);
        }else{
            setSelectedFareObj(null);
        }
    };

    const findNearbyDrivers = async() =>{
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/find_nearby_drivers`;
            const body={
                token: token, 
                // timestamp: timestamp, 
                is_panel_request:1, 
                ride_distance: rideDistance/1000,
                ride_eta: Math.round(rideEta),
                pickup_latitude: String(pickupLatLng.lat),
                pickup_longitude: String(pickupLatLng.lng),
                drop_latitude: String(dropLatLng.lat),
                drop_longitude: String(dropLatLng.lng),
                encoded_polyline: String(polyLine),
                city_id: cityFilter
            }

            const response =  await makePostRequestToUrl(url, body);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            else if(response.flag == 200){
                const vehicleDetails = response.data.vehicle_details;
                const driversData = [];
                setVehicleDetails(vehicleDetails);
                for(var i=0;i<vehicleDetails.length;i++){
                    for(var j=0;j<vehicleDetails[i].active_driver.length;j++){
                        driversData.push(vehicleDetails[i].active_driver[j]);
                    }
                }
                setDriversData(driversData);
                setIsNearbyDrivers(true);
            }

            else if(response.flag==113){
                setDriversData([]);
                // setNoServiceAvailable(true);
            }
            else {
                setDriversData([]);
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        if(dropLatLng && polyLine ){
            findNearbyDrivers();
        }
    },[dropLatLng, polyLine, pickupLatLng]);

    // Debug effect for userStopMapping changes
    useEffect(() => {
        console.log('userStopMapping updated:', userStopMapping);
    }, [userStopMapping]);

    const scheduleBooking = async() => {
        console.log('Current userStopMapping in scheduleBooking:', userStopMapping);
        
        // Create a mapping of user_code to user_id for lookup
        const userCodeToIdMap = {};
        additionalUserIds.forEach(user => {
            userCodeToIdMap[user.user_code] = user.user_id;
        });

        // Create the final mapping with user_ids
        // Create the final mapping with user_ids and their corresponding stop_ids
        const poolUserStopMapping = {};

        // Create a mapping of addresses to their stop_ids from modalWayPoints
        const addressToStopIdMap = {};
        modalWayPoints.forEach(waypoint => {
            if (waypoint.address && waypoint.stop_id) {
                addressToStopIdMap[waypoint.address] = waypoint.stop_id;
            }
        });

        const finalStopMapping = {};

        // First, process all users and their stops
        additionalUserIds.forEach(user => {
            // Check userStopMapping first (this will have the most recent values)
            const stopValue = userStopMapping[user.user_code] ?? 
                            userStopMapping[user.user_id] ?? 
                            user.user_stop;

            // Only process if we have a valid stop value
            if (stopValue !== undefined && stopValue !== null) {
                if (stopValue === 0) {
                    // Pickup
                    finalStopMapping[user.user_id] = 0;
                } else if (stopValue === -1) {
                    // Drop
                    finalStopMapping[user.user_id] = -1;
                } else if (typeof stopValue === 'number' || !isNaN(parseInt(stopValue))) {
                    // Regular stop - ensure it's a number
                    const numValue = Number(stopValue);
                    if (numValue > 0) {
                        finalStopMapping[user.user_id] = numValue;
                    }
                }
            }
        });

        // Then process any remaining stops from userStopMapping that might not be in additionalUserIds
        Object.entries(userStopMapping).forEach(([key, value]) => {
            // Skip if we've already processed this user
            if (additionalUserIds.some(u => u.user_id === key || u.user_code === key)) {
                return;
            }

            // Check if the key is a user_id or user_code
            const userId = userCodeToIdMap[key] || key;
            
            // Only process if we have a valid stop value
            if (value === 0 || value === -1 || (typeof value === 'number' && value > 0)) {
                finalStopMapping[userId] = value;
            }
        });

        // Update the final mapping with any address-based stops
        additionalUserIds.forEach(user => {
            if (user.user_stop && typeof user.user_stop === 'string') {
                const stopId = addressToStopIdMap[user.user_stop];
                if (stopId) {
                    finalStopMapping[user.user_id] = stopId;
                }
            }
        });

        console.log('Final poolUserStopMapping with stop_ids:', poolUserStopMapping);
        
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${autosUrl}/customer/post_scheduled_ride`;
            let filteredStops=[];

            if(stops.length &&stops[0]?.address!=''){
                filteredStops = stops.filter(stop => stop.address && stop.address.trim() !== '');
            }
            if(stopIds.length && stopIds[0]?.locationId!=''){
                filteredStops = stopIds
                .filter(stop => stop.locationId && stop.locationId !== '')
                .map(stop => {
                    const matchingLocation = pickupDropLocationData.find(loc => loc.id === stop.locationId);
                    return {
                        address: matchingLocation ? matchingLocation.address_name : '', // fallback to empty string if not found
                        latitude: matchingLocation ? matchingLocation.latitude : stop.latitude,
                        longitude: matchingLocation ? matchingLocation.longitude : stop.longitude,
                        stop_id: stop.stop_id
                    };
                });
            }
            // Around line 1903, before the API call
// const waypoints = modalWayPoints
//     .filter(waypoint => waypoint.address && waypoint.address.trim() !== '')
//     .map(waypoint => ({
//         address: waypoint.address,
//         latitude: waypoint.latitude.toString(),
//         longitude: waypoint.longitude.toString(),
//         stop_id: waypoint.stop_id
//     }));

// // Add pickup and drop to waypoints if they exist in user_stop_mapping
// if (Object.values(poolUserStopMapping).includes(0) && pickupLocation) {
//     const pickupLoc = pickupLocationData.find(loc => loc.id === pickupLocation);
//     if (pickupLoc) {
//         waypoints.unshift({
//             address: pickupLoc.address_name,
//             latitude: pickupLoc.latitude.toString(),
//             longitude: pickupLoc.longitude.toString(),
//             stop_id: 0
//         });
//     }
// }

// if (Object.values(poolUserStopMapping).includes(-1) && dropLocation) {
//     const dropLoc = dropLocationData.find(loc => loc.id === dropLocation);
//     if (dropLoc) {
//         waypoints.push({
//             address: dropLoc.address_name,
//             latitude: dropLoc.latitude.toString(),
//             longitude: dropLoc.longitude.toString(),
//             stop_id: -1
//         });
//     }
// }
            if(modalWayPoints.length && modalWayPoints[0]?.address!=''){
                filteredStops = modalWayPoints.filter(stop => stop.address && stop.address.trim() !== '');
            }
            let userIdsArr = [];
            if(additionalUserIds.length){
                userIdsArr = additionalUserIds.map(user => user.user_id);
            }
            const body={
                // token: token, 
                // timestamp: timestamp,
                is_panel_request:1, 
                ride_distance: rideDistance/1000,
                vehicle_id: vehicleId,
                ride_eta: Math.round(rideEta),
                pickup_latitude: String(pickupLatLng.lat),
                pickup_longitude: String(pickupLatLng.lng),
                drop_latitude: String(dropLatLng.lat),
                drop_longitude: String(dropLatLng.lng),
                // pickup_address: pickupLocationData.find(loc => loc.id === pickupLocation)?.address,
                // drop_address: dropLocationData.find(loc => loc.id === dropLocation)?.address,
                estimated_fare: estimatedFare.toFixed(2),
                pickup_time: dayjs(dateTime).utc().format('YYYY-MM-DD HH:mm:ss'),
                waypoints: filteredStops,
                user_id: userByPhone.user_id,
                payment_mode: 1,
                admin_id: admin_id
            }
            if(panel_customer_specific_address==1){
                body.pickup_address = pickupLocationData.find(loc => loc.id === pickupLocation)?.address_name;
                body.drop_address = dropLocationData.find(loc => loc.id === dropLocation)?.address_name;
            }
            else{
                body.pickup_address = pickupAddress;
                body.drop_address = dropAddress;
            }
            if(selectedFareObj){
                body['fare_obj'] = selectedFareObj;
            }
            if (Object.keys(finalStopMapping).length > 0) {
                body['user_stop_mapping'] = finalStopMapping;
            }

            if(assignDriver.shift_id && assignDriver.shift_id!=0) body['driver_shift_id'] = assignDriver.shift_id;
            if(assignDriver.shift_vehicle_id && assignDriver.shift_vehicle_id!=0) body['vehicle_make_id'] = assignDriver.shift_vehicle_id;
            if(assignDriver.driver_id && assignDriver.driver_id!=0) body['driver_id'] = assignDriver.driver_id;
            if(userIdsArr.length){
                body['pool_users'] = userIdsArr;
            }

            const response = await makePostRequestToUrl(url, body);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                setMessage(response.message);
                showSnackbar(true);
                fetchScheduledBookings();
                setOpenAddModal(false);
                setAssignDriver({
                    driver_id: '',
                    driver_name: '',
                    driver_phone_number: '',
                    shift_id: '',
                    shift_vehicle_id: '',
                });
                setNoDriverMessage(false);
                setAdditionalUserIds([]);
                setDriverFilter('');
            }
            else {
                setMessage(response.message);
                showSnackbar(true);
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleCancelBooking =  (row) => {
        if(is_bulk_assign_enabled>0) getOngoingRideIds();
        setPoolUsersData(row?.pool_users);
        setSelectedRow(row);
        if(checkOngoingBulkRideId(row.ride_id)){
            setRideIdUnderProcessModalOpen(true);
            return;
        }
        else{
            setOpenCancelBookingModal(true);
            setCancelBookingRow(row);
            setCancelBookingReason('');
        }
    }

    const handleCancelBookingApi = async() => {
        try{

            const url = `${autosUrl}/customer/cancel_scheduled_rides`;
            const body={
                ride_id: cancelBookingRow.ride_id,
                // cancellation_reason: cancelBookingReason,
                is_panel_request: 1,
                user_id: cancelBookingRow.user_id,
                no_driver_found: noDriverMessage ? 1 : 0,
                admin_id: admin_id
            }
            if(cancelBookingReason!=""){
                body['cancellation_reason'] = cancelBookingReason;
            }
            if(hide_fare_on_map_view_cancel == 0){
                body['admin_refund_percentage'] = refundPercentage;
            }
            const response = await makePostRequestToUrl(url, body);
            if(response.flag==200){
                setOpenAssignModal(false);
                setSelectedRow(null);
            }

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                setMessage(response.message);
                showSnackbar(true);
                setOpenCancelBookingModal(false);
                fetchScheduledBookings();
            }
            else {
                setMessage(response.message);
                showSnackbar(true);
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    // Ensure stopIds always have sequential stop_id values
    const reindexStopIds = (list) => list.map((s, i) => ({ ...s, stop_id: i + 1 }));

    const handleAddStopIds = () => {
        if (stopIds.length >= 3) {
            setMessage('Maximum 3 stops are allowed');
            showSnackbar(true);
            return;
        }
        // Do not allow adding if previous stop does not have a selected address (empty locationId)
        if (stopIds.length > 0) {
            const lastStop = stopIds[stopIds.length - 1];
            if (!lastStop.locationId) {
                setMessage('Please select the previous stop address before adding a new stop');
                showSnackbar(true);
                return;
            }
        }
        setStopIds(prevStopIds => {
            const newStop = {
                address: '',
                latitude: '',
                longitude: '',
                stop_id: prevStopIds.length + 1,
                locationId: ''
            };
            return reindexStopIds([...prevStopIds, newStop]);
        });
    };

    const handleRemoveStopIds = (index) => {
        setStopIds(prevStopIds => {
            const newStops = [...prevStopIds];
            newStops.splice(index, 1);
            return reindexStopIds(newStops);
        });
        // Reset vehicle selection as route changes
        setVehicleId('');
        setVehicleType('');
    };

    const exportCSV = () => {
        // Build columns to export based on visible columns (exclude action)
        const columnsToExport = getVisibleColumns().filter(col => col.id !== 'action');

        console.log('columnsToExport', columnsToExport)
        // CSV headers from visible column labels
        const headers = columnsToExport.map(col => col.label);

        // Helper to format values similar to table rendering
        const formatValue = (row, id, isCSV = false) => {
            switch (id) {
                case 'user_name':
                    return row.user_id + ' - ' + row.user_name + ' (' + row.user_phone_number + ')';
                case 'driver_name':
                    return row.driver_id ? row.driver_id + ' - ' + row.driver_name + ' (' + row.driver_phone_number + ')' : '-';
                case 'engagement_status':
                    return row.engagement_status == 2
                        ? 'Accepted'
                        : row.engagement_status == 3
                        ? 'Arrived'
                        : row.engagement_status == 5
                        ? 'Started'
                        : row.engagement_status == 6
                        ? 'Ended'
                        : '--';
                case 'waypoints':
                    if (isCSV) {
                        // For CSV export, join waypoints with a separator
                        return row?.waypoints?.map(w => w.address).filter(Boolean).join(' | ') || '--';
                    }
                    // For table display
                    return row?.waypoints?.length > 0 ? (
                        <ul>
                            {row.waypoints.map((waypoint, index) => (
                                <li key={index}>{waypoint.address || `Waypoint ${index + 1}`}</li>
                            ))}
                        </ul>
                    ) : '--';
                case 'status':
                    return row?.status == 1
                        ? 'Unassigned'
                        : row.status == 2
                        ? 'In Progress'
                        : row.status == 3
                        ? 'Assigned'
                        : row.status == 4
                        ? 'Processed and no driver assigned'
                        : row.status == 5
                        ? 'Cancelled By Customer'
                        : row.status == 6
                        ? 'Ended'
                        : row.status == 7
                        ? 'Customer No Show'
                        : row.status == 8
                        ? 'Cancelled By Admin'
                        : row.status == 9
                        ? 'Cancelled By System'
                        : '--';
                case 'vehicle_type':
                    return row.vehicle_type == 1
                        ? 'Taxi'
                        : row.vehicle_type == 2
                        ? 'Bike'
                        : row.vehicle_type == 3
                        ? 'Autos'
                        : row.vehicle_type == 4
                        ? 'Shuttle'
                        : '--';
                case 'payment_mode':
                    return constants.paymentMode[row.payment_mode || 1]
                case 'pickup_time': {
                    if (!row.pickup_time) return '';
                    const d = new Date(row.pickup_time);
                    d.setMinutes(d.getMinutes() + utcOffset);
                    return d
                        .toLocaleString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: timeZoneFormat == '12' ? true : false,
                            timeZone: 'UTC',
                        })
                        .replace(',', ' |');
                }
                case 'driver_arrival_time': {
                    if (!row.driver_arrival_time) return '';
                    const d = new Date(row.driver_arrival_time);
                    d.setMinutes(d.getMinutes() + utcOffset);
                    return d
                        .toLocaleString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: timeZoneFormat == '12' ? true : false,
                            timeZone: 'UTC',
                        })
                        .replace(',', ' |');
                }
                case 'created_at': {
                    if (!row.created_at) return '';
                    const d = new Date(row.created_at);
                    // d.setMinutes(d.getMinutes() + utcOffset);
                    return d
                        .toLocaleString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: timeZoneFormat == '12' ? true : false,
                            timeZone: 'UTC',
                        })
                        .replace(',', ' |');
                }
                default:
                    return row[id] ?? '';
            }
        };
        // Build CSV rows based on visible columns
        const csvData = rows.map(row => columnsToExport.map(col => formatValue(row, col.id, true)));

        let csvContent = headers.join(',') + '\n';

        csvData.forEach(rowArray => {
            const formattedRow = rowArray.map(field => {
                const stringField = String(field ?? '');
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    return `"${stringField.replace(/"/g, '""')}"`;
                }
                return stringField;
            });
            csvContent += formattedRow.join(',') + '\n';
        });

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.setAttribute('href', url);
        link.setAttribute('download', `scheduled_bookings.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const processBulkAssign = async() => {
        const token = localStorage.getItem('token');
        try{
            const payload = {
                start_date: bulkDate.format('YYYY-MM-DD'), 
                end_date: bulkDate.format('YYYY-MM-DD'),
                ride_status: statusFilter==1? 1: statusFilter==4 ? 2: statusFilter==10 ? 3: 0,
                city_id: cityFilter,
                token
            }
            let url = operationsUrl + '/admin-panel/bulk_assign_scheduled_ride';
            
            const response = await makePostRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                setJobIdOnButtonClick(response.data.job_id);
            } else {
                setMessage(response.message);
                showSnackbar(true);
            }
        } catch(error){
            console.log(error);
        }
    }

    const fetchJobStatus = async() => {
        const token = localStorage.getItem('token');
        try{
            const payload={
                token,
                job_id: jobIdOnButtonClick
            }
            let url = serverUrl + '/panel/fetch_job_status';
            
            const response = await makeGetRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                setJobStatusOnButtonClick(response.data[0]);
                // fetchScheduledBookings();
                console.log('status==---', response.data[0].status)
                if(response.data[0].status == 2 || response.data[0].status == 3){
                    setAssignInProgress(false);
                    if (response.data[0].status == 3) {
                        setOpenBulkFailedModal(true);
                        setOpenJobStatusModal(false);
                    } else if(response.data[0].status == 2) {
                        setOpenJobStatusModal(true);
                    }
                    fetchScheduledBookings();
                }
            } else {
                setMessage(response.message);
                showSnackbar(true);
            } 
        } catch(error){
            console.log(error);
        }
    }

    useEffect(() => {
        // Clear any existing timer when jobId changes
        if (pollTimerRef.current) {
            clearInterval(pollTimerRef.current);
            pollTimerRef.current = null;
        }

        if (jobIdOnButtonClick) {
            setAssignInProgress(true);
            // Call immediately once after API triggers a new job id
            fetchJobStatus();
            // Start polling every 2s
            pollTimerRef.current = setInterval(() => {
                // Stop if completed or failed
                if (jobStatusOnButtonClick?.status === 2 || jobStatusOnButtonClick?.status === 3) {
                    setAssignInProgress(false);
                    clearInterval(pollTimerRef.current);
                    pollTimerRef.current = null;
                    return;
                }
                // Continue polling
                fetchJobStatus();
            }, 2000);

            // Cleanup on unmount/jobId change
            return () => {
                if (pollTimerRef.current) {
                    clearInterval(pollTimerRef.current);
                    pollTimerRef.current = null;
                }
            };
        } else {
            setAssignInProgress(false);
        }
    }, [jobIdOnButtonClick, jobStatusOnButtonClick?.status])

    const getOngoingJobs = async() => {
        const token = localStorage.getItem('token');
        try{
            const payload={
                token,
                status: 1,
                event_type: 1,
                start_date: bulkDate.format('YYYY-MM-DD'),
                end_date: bulkDate.format('YYYY-MM-DD'),
                ride_status: statusFilter==1? 1: statusFilter==4 ? 2: statusFilter==10 ? 3: 0,
                city_id: cityFilter
            }
            let url = serverUrl + '/panel/fetch_background_jobs';
            
            const response = await makeGetRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                // setOngoingJobRidesData(response.data.rides);
                setJobIdOnButtonClick(response.data.job_id);
                // fetchScheduledBookings();
            } else {
                setMessage(response.message);
                showSnackbar(true);
            } 
        } catch(error){
            console.log(error);
        }
    }

    const getOngoingRideIds = async() => {
        const token = localStorage.getItem('token');
        try{
            const payload={
                token,
                status: 1,
                event_type: 1
            }
            let url = serverUrl + '/panel/fetch_background_jobs';
            
            const response = await makeGetRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                setOngoingJobRidesData(response.data.rides);
                // setJobIdOnButtonClick(response.data.job_id);
                // fetchScheduledBookings();
            } else {
                setMessage(response.message);
                showSnackbar(true);
            } 
        } catch(error){
            console.log(error);
        }
    }
    
    const checkOngoingBulkRideId = (rideId) => {
        console.log('rideId = ', rideId)
        // const ongoingRideIds = ongoingJobRidesData.map(ride => ride.ride_id);
        // console.log('ongoingRideIds = ', ongoingRideIds)
        console.log('ongoingJobRidesData = ', ongoingJobRidesData)
        console.log('ongoingJobRidesData.includes(rideId) = ', ongoingJobRidesData.includes(rideId))
        return ongoingJobRidesData.includes(rideId);
    }

    useEffect(()=> {
        if(isBulkAssign && is_bulk_assign_enabled>0){
            getOngoingJobs();
        }
    }, [bulkDate, isBulkAssign, statusFilter])

    const fetchMainCityDrivers = async () => {
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            // const url = `${serverUrl}/driver/fetch_city_driver`;
            const url = serverUrl + "/driver/city_online_driver"
            const obj={
                token: token, 
                timestamp: timestamp,
                city_id: cityFilter,
                scheduled_ride_details: {
                    pickup_time: dayjs(dateTime).utc().format('YYYY-MM-DD HH:mm:ss'),
                    pickup_latitude: String(pickupLatLng?.lat),
                    pickup_longitude: String(pickupLatLng?.lng),
                    drop_latitude: String(dropLatLng?.lat),
                    drop_longitude: String(dropLatLng?.lng),
                    ride_distance: rideDistance/1000,
                    user_id: userByPhone.user_id,
                    vehicle_type: vehicleType,
                    ride_time: rideEta
                }
            }
            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==411){
                setNoDriverMessage(response.message);
                setMainDriversData([]);
                setDriversData([]);
                setAssignDriver({
                    driver_id: '',
                    driver_name: '',
                    driver_phone_number: '',
                    shift_id: '',
                    shift_vehicle_id: '',
                });
            }

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const cityDriversData = response.data;
                setMainDriversData(cityDriversData);
                setDriversData(cityDriversData);
                setNoDriverMessage('');
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleOpenAddClientModal = () => {
        setModalPickupDropLocData([]);
        setFlagFetchingStops(false);
        if(Boolean(seatCount) && additionalUserIds.length >= Number(seatCount)){
            setAddClientModal(false);
            showSnackbar(true);
            setMessage('You can only add upto ' + seatCount + ' passengers.');
        }
        else{
            setAddClientModal(true);
        }
    };

    const handleCloseAddClientModal = () => {
        setAddClientModal(false);
        setModalCustomerPhone('');
        setModalUserCodeSearch('');
        setModalUSerId('');
        setModalUserName('');
        setModalPickupDropLocData([]);
        setFlagFetchingStops(false);  // Reset the flag when modal is closed
    };

    const removeAddedClient = (id) => {
        // Find the user being removed to get their stop address
        const userToRemove = additionalUserIds.find(user => user.user_id === id);
        
        // Remove the user from additionalUserIds
        const updatedUserIds = additionalUserIds.filter(x => x.user_id !== id);
        setAdditionalUserIds(updatedUserIds);
        
        // If user has a stop, update the modalWayPoints
        if (userToRemove?.user_stop) {
            // Remove the waypoint and update stop_id sequence
            setModalWayPoints(prev => {
                // Filter out the waypoint being removed and any with empty addresses
                const updatedWaypoints = prev.filter(waypoint => 
                    waypoint.address !== userToRemove.user_stop && 
                    waypoint.address && 
                    waypoint.address.trim() !== ''
                );
                
                // Reassign stop_id in sequential order
                return updatedWaypoints.map((waypoint, index) => ({
                    ...waypoint,
                    stop_id: index + 1
                }));
            });
        }
    };

    const searchAddClient = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = serverUrl + "/customer/user_by_phone_no";
            const obj = { token, timestamp };

            if (modalSearchByClient) {
                if (!modalUserCodeSearch) {
                    setMessage('Please enter Client ID');
                    showSnackbar(true);
                    return;
                }
                obj['user_code'] = modalUserCodeSearch;
            } else {
                if (!modalCustomerPhone) {
                    setMessage('Please enter phone number');
                    showSnackbar(true);
                    return;
                }
                obj['phone_number'] = modalCustomerPhone;
            }

            const response = await makeGetRequestToUrl(url, obj);

            if (response.flag == 102) {
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => navigate('/signup'), 2000);
                return;
            }

            if (response.flag === 200) {
                setFlagFetchingStops(true);
                const details = response.data.user_details;
                const newId = details?.user_id;
                const newName = details?.user_name;
                // fetchAddress(newId);
                setModalUSerId(newId);
                setModalUserName(newName);

                if (!newId) {
                    setMessage('User not found');
                    showSnackbar(true);
                    return;
                }
                // In searchAddClient function, around line 2622
            const isUserAlreadyAdded = additionalUserIds.some(u => 
                u.user_id === newId || 
                (modalCustomerPhone && u.phone_number === modalCustomerPhone)
            );

            if (isUserAlreadyAdded) {
                // If user is already added, update the modal fields to show their existing selection
                const existingUser = additionalUserIds.find(u => 
                    u.user_id === newId || 
                    (modalCustomerPhone && u.phone_number === modalCustomerPhone)
                );
                
                if (existingUser) {
                    setModalUSerId(existingUser.user_id);
                    setModalUserName(existingUser.user_name);
                    setModalUserCodeSearch(existingUser.user_code || '');
                    
                    // If the existing user has a stop mapping, update the UI to show it
                    if (existingUser.user_stop !== undefined) {
                        // Preserve the existing stop mapping
                        setUserStopMapping(prev => ({
                            ...prev,
                            [existingUser.user_code || existingUser.user_id]: existingUser.user_stop
                        }));
                        
                        // Don't clear the modal fields here to show the existing stop
                        setMessage('This user is already added to the booking');
                        showSnackbar(true);
                        return;
                    }
                }
                
                // Only clear if we didn't find an existing user with a stop
                setModalCustomerPhone('');
                setModalUserCodeSearch('');
                setMessage('This user is already added to the booking');
                showSnackbar(true);
                return;
            }
                if (userByPhone?.user_id && newId === userByPhone.user_id) {
                    setMessage('Primary client is already selected');
                    showSnackbar(true);
                    return;
                }
                if (additionalUserIds.some(u => u.user_id === newId)) {
                    setMessage('Client already added');
                    showSnackbar(true);
                    return;
                }
                if (seatCount && additionalUserIds.length >= Number(seatCount)) {
                    setMessage(`You can add up to ${seatCount} clients`);
                    showSnackbar(true);
                    return;
                }

                // Get the selected stop for the current user
                // Get the selected stop for the current user
                
            } else {
                setMessage(response.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const addingClient = async() => {
        if(!flagFetchingStops){
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();
                const url = serverUrl + "/customer/user_by_phone_no";
                const obj = { token, timestamp };

                if (modalSearchByClient) {
                    if (!modalUserCodeSearch) {
                        setMessage('Please enter Client ID');
                        showSnackbar(true);
                        return;
                    }
                    obj['user_code'] = modalUserCodeSearch;
                } else {
                    if (!modalCustomerPhone) {
                        setMessage('Please enter phone number');
                        showSnackbar(true);
                        return;
                    }
                    obj['phone_number'] = modalCustomerPhone;
                }

                const response = await makeGetRequestToUrl(url, obj);

                if (response.flag === 200) {
                    const details = response.data.user_details;
                    const newId = details?.user_id;
                    const newName = details?.user_name;
                    // fetchAddress(newId);
                    setModalUSerId(newId);
                    setModalUserName(newName);

                    if (!newId) {
                        setMessage('User not found');
                        showSnackbar(true);
                        return;
                    }
                    if (userByPhone?.user_id && newId === userByPhone.user_id) {
                        setMessage('Primary client is already selected');
                        showSnackbar(true);
                        return;
                    }
                    if (additionalUserIds.some(u => u.user_id === newId)) {
                        setMessage('Client already added');
                        showSnackbar(true);
                        return;
                    }
                    if (seatCount && additionalUserIds.length >= Number(seatCount)) {
                        setMessage(`You can add up to ${seatCount} clients`);
                        showSnackbar(true);
                        return;
                    }

                    setAdditionalUserIds(prev => {
                        // Check if user already exists (by ID or phone)
                        const existingUserIndex = prev.findIndex(u => 
                            u.user_id === newId || 
                            (modalCustomerPhone && u.phone_number === modalCustomerPhone)
                        );

                        if (existingUserIndex !== -1) {
                            // Update existing user
                            const updated = [...prev];
                            updated[existingUserIndex] = {
                                ...updated[existingUserIndex],
                                user_name: newName,
                                user_code: modalUserCodeSearch,
                                ...(selectedStop !== undefined && { user_stop: address })
                            };
                            return updated;
                        } else {
                            // Add new user
                            return [...prev, { 
                                user_id: newId, 
                                user_name: newName,
                                user_code: modalUserCodeSearch,
                                ...(modalCustomerPhone && { phone_number: modalCustomerPhone }),
                                ...(selectedStop !== undefined && { user_stop: address })
                            }];
                        }
                    });
                    
                } else {
                    setMessage(response.message);
                    showSnackbar(true);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        else{

            setAdditionalUserIds(prev => {
                // Check if user already exists (by ID or phone)
                const existingUserIndex = prev.findIndex(u => 
                    u.user_id === modalUSerId || 
                    (modalCustomerPhone && u.phone_number === modalCustomerPhone)
                );

                if (existingUserIndex !== -1) {
                    // Update existing user
                    const updated = [...prev];
                    updated[existingUserIndex] = {
                        ...updated[existingUserIndex],
                        user_name: modalUserName,
                        user_code: modalUserCodeSearch,
                        ...(selectedStop !== undefined && { user_stop: address })
                    };
                    return updated;
                } else {
                    // Add new user
                    return [...prev, { 
                        user_id: modalUSerId, 
                        user_name: modalUserName,
                        user_code: modalUserCodeSearch,
                        ...(modalCustomerPhone && { phone_number: modalCustomerPhone }),
                        ...(selectedStop !== undefined && { user_stop: address })
                    }];
                }
            });
        }
        
        const selectedStop = userStopMapping[modalUserCodeSearch];
        const matchingAddress = modalPickupDropLocData.find(stop => stop.id === selectedStop);

        const address = matchingAddress ? matchingAddress.address_name : '';

        setModalWayPoints(prev => {
            // Only add the new waypoint if address is not empty
            if (address && address.trim() !== '') {
                return [
                    ...prev.filter(waypoint => 
                        waypoint.address && waypoint.address.trim() !== ''
                    ),
                    {
                        address: address,
                        latitude: matchingAddress ? matchingAddress.latitude : '',
                        longitude: matchingAddress ? matchingAddress.longitude : '',
                        stop_id: prev.filter(waypoint => 
                            waypoint.address && waypoint.address.trim() !== ''
                        ).length + 1
                    }
                ];
            }
            return prev;
        });


        setMessage('Client added');
        showSnackbar(true);
        setModalCustomerPhone('');
        setModalUserCodeSearch('');
        setModalUSerId('');
        setModalUserName('');
        setModalPickupDropLocData([]);
        setFlagFetchingStops(false);
    }

    return (
        <div>

            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Scheduled Bookings</Typography>
            
            <Grid2 container spacing={1.5} xs={12} md={8} alignItems="flex-end" sx={{ marginTop: '1%'}}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '180px',height:'44px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item>
                    <Select
                        value={statusFilter}
                        onChange={(e) => handleStatusChange(e.target.value)}
                        displayEmpty
                        style={{
                            width: '180px',
                            height: '44px',
                            borderRadius: '8px',
                            backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        {!isBulkAssign && <MenuItem value="">Select Status</MenuItem>}
                        <MenuItem value="1">Unassigned</MenuItem>
                        {!isBulkAssign && <MenuItem value="2">In Progress</MenuItem>}
                        {!isBulkAssign && <MenuItem value="3">Assigned</MenuItem>}
                        <MenuItem value="4">Processed and no driver assigned</MenuItem>
                        {!isBulkAssign && <MenuItem value="5">Cancelled By Customer</MenuItem>}
                        {isBulkAssign && <MenuItem value="10">Both</MenuItem>}
                        <MenuItem value="6">Ended</MenuItem>
                        <MenuItem value="7">Customer No Show</MenuItem>
                        <MenuItem value="8">Cancelled By Admin</MenuItem>
                        <MenuItem value="9">Cancelled By System</MenuItem>

                    </Select>
                </Grid2>

                {!isBulkAssign &&
                    <Grid2 item>
                        <Label>Start Date:</Label><br/>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                slotProps={{ 
                                    textField: { 
                                        size: 'small',
                                        error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                    } 
                                }}
                                sx={{
                                    width: '190px',
                                    '& .MuiInputBase-root': {
                                        minHeight: '44px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        marginTop:'4px',
                                        minWidth:'190px'
                                    }
                                }}
                                disabled={isToday}
                                value={camefromnavbar && selectedridePickupDate ? dayjs(selectedridePickupDate) : startDateFilter}
                                format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                                onChange={(newValue) => {
                                    if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                        setEndDateFilter(null);
                                    }
                                    setStartDateFilter(newValue);
                                }}
                                maxDate={endDateFilter || undefined}
                            />
                        </LocalizationProvider>
                    </Grid2>
                }

                {!isBulkAssign &&
                    <Grid2 item>
                        <Label>End Date:</Label><br/>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                                slotProps={{ 
                                    textField: { 
                                        size: 'small',
                                        error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                    } 
                                }}
                                sx={{
                                    width: '190px',
                                    '& .MuiInputBase-root': {
                                        minHeight: '44px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        marginTop:'4px',
                                        minWidth:'190px'
                                    }
                                }}
                                disabled={isToday}
                                value={camefromnavbar && selectedridePickupDate ? dayjs(selectedridePickupDate) : endDateFilter}
                                onChange={(newValue) => {
                                    setEndDateFilter(newValue)
                                }}
                                minDate={startDateFilter || undefined}
                            />
                        </LocalizationProvider>
                    </Grid2>
                }

                {!isBulkAssign &&
                    <Grid2 item>
                        <Select
                            value={driverFilter}
                            onChange={(e) => handleDriverFilterChange(e.target.value)}
                            displayEmpty
                            style={{
                                width: '170px',
                                height: '44px',
                                borderRadius: '8px',
                                backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF',
                            }}
                        >
                            <MenuItem value="" sx={{fontSize:'14px'}}>All Drivers</MenuItem>
                            {Array.from(
                                new Map(
                                    (rows || [])
                                        .filter(r => r && r.driver_id !== null && r.driver_id !== undefined && r.driver_id !== '')
                                        .map(r => [String(r.driver_id), r.driver_name || `Driver ${r.driver_id}`])
                                ).entries()
                            ).map(([id, name]) => (
                                <MenuItem key={id} value={id} sx={{fontSize:'14px'}}>{name} <span style={{color:'#AC8312', marginLeft:"4px"}}> (ID: {id})</span></MenuItem>
                            ))}
                        </Select>
                    </Grid2>
                }

                <Grid2 xs="auto">
                    <Label>Ride Id:</Label><br/>
                    <input type="number" placeholder="Ride Id" className='filterBtn' value={notificationRideId} onChange={handlerideIdChange} min="0"
                    onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                            e.preventDefault();
                        }
                    }}
                    style={{
                        width: '170px',
                        height: '40px',
                        borderRadius: '8px',
                        backgroundColor: rideId ? '#F9F9F9' : '#FFFFFF',
                        border: '1px solid #d2d1d1ff',
                        marginTop:'4px'
                    }}
                        />
                </Grid2>

                <Grid2 xs="auto">
                    <Label>Customer Id:</Label><br/>
                    <input type="number" placeholder="Customer Id" className='filterBtn' value={customerIdFilter} onChange={handleCustomerIdChange} min="0"
                        onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                            }
                        }}
                        style={{
                            width: '170px',
                            height: '40px',
                            borderRadius: '8px',
                            backgroundColor: rideId ? '#F9F9F9' : '#FFFFFF',
                            border: '1px solid #d2d1d1ff',
                            marginTop:'4px'
                        }}
                        />
                </Grid2>
                {clientId == 188 && <Grid2 xs="auto">
                    <Label>Client Id:</Label><br/>
                    <input placeholder="Client Id" className='filterBtn' value={clientIdFilter} onChange={handleClientIdChange}
                        style={{
                            width: '170px',
                            height: '40px',
                            borderRadius: '8px',
                            backgroundColor: rideId ? '#F9F9F9' : '#FFFFFF',
                            border: '1px solid #d2d1d1ff',
                            marginTop:'4px'
                        }}
                        />
                </Grid2>}

                <Grid2 xs="auto">
                    <Label>Customer Name:</Label><br/>
                    <input type="text" placeholder="Customer Name" className='filterBtn' value={customerNameFilter} onChange={handleCustomerNameChange} min="0"
                        style={{
                            width: '170px',
                            height: '40px',
                            borderRadius: '8px',
                            backgroundColor: rideId ? '#F9F9F9' : '#FFFFFF',
                            border: '1px solid #d2d1d1ff',
                            marginTop:'4px'
                        }}
                    />
                </Grid2>

                {isBulkAssign &&
                    <Grid2 item>
                        <Label>Date:</Label><br/>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                                slotProps={{ 
                                    textField: { 
                                        size: 'small',
                                    } 
                                }}
                                sx={{
                                    width: '190px',
                                    '& .MuiInputBase-root': {
                                        height: '44px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        marginTop:'4px'
                                    }
                                }}
                                value={bulkDate}
                                onChange={(newValue) => {
                                    setJobIdOnButtonClick('')
                                    setJobStatusOnButtonClick('')
                                    setBulkDate(newValue)
                                }}
                            />
                        </LocalizationProvider>
                    </Grid2>
                }

                {is_bulk_assign_enabled>0 && 
                    <Grid2 item sx={{display:'flex', alignItems:'center', border:isBulkAssign ? '1px solid #0065ff' : '1px solid gray', borderRadius:'8px', padding:'2px 8px', backgroundColor:'#fff'}}>
                        <Typography sx={{color: isBulkAssign ? '#0065ff' : '#000'}}>Bulk Assign:</Typography>
                        <Switch checked={isBulkAssign} 
                            onChange={(e) => {
                                setIsBulkAssign(e.target.checked)
                                if(e.target.checked){
                                    handleStatusChange(10)
                                    setAssignInProgress('')
                                    setJobStatusOnButtonClick('')
                                    // getOngoingJobs()
                                }
                                else{
                                    setJobIdOnButtonClick('')
                                    setAssignInProgress('')
                                    setStatusFilter('')
                                    setStartDateFilter(bulkDate);
                                    setEndDateFilter(bulkDate);
                                    setDriverFilter('');
                                }
                            }} 
                            inputProps={{ 'aria-label': 'controlled' }} 
                        />
                    </Grid2>
                }

                <Grid2 item sx={{display:'flex', alignItems:'center', border:isToday ? '1px solid #0065ff' : '1px solid gray', borderRadius:'8px', padding:'2px 8px', backgroundColor:'#fff'}}>
                        <Typography sx={{color: isToday ? '#0065ff' : '#000'}}>Today :</Typography>
                        <Switch checked={isToday} 
                            onChange={(e) => {
                                setIsToday(e.target.checked)
                                if(e.target.checked){
                                    setStartDateFilter(dayjs());
                                    setEndDateFilter(dayjs());
                                }
                                else{
                                    setStartDateFilter(dayjs().startOf('month').startOf('day'));
                                    setEndDateFilter(dayjs().endOf('month').endOf('day'));
                                }
                            }} 
                            inputProps={{ 'aria-label': 'controlled' }} 
                        />
                    </Grid2>

                {(show_create_schedule_ride_button==1 && !isBulkAssign) && 
                    <Grid2 item>
                        <Button
                            variant="contained" 
                            onClick={handleOpenAddBooking}
                            style={{width:'180px',height: '42px',backgroundColor:'#0065FF',textTransform:'none',borderRadius:'8px'}}>
                            + Create Booking
                        </Button>
                    </Grid2>
                }

                <Grid2 item sx={{marginLeft:'auto'}}>
                    <Label></Label><br/>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={exportCSV}
                        sx={{
                            height: '40px', marginLeft:'auto',
                            textTransform: 'none',
                            borderRadius: '8px',
                            backgroundColor: '#36C68F',
                            '&:hover': {
                                backgroundColor: '#36C68F',
                            },
                        }}
                    >
                        Export CSV
                    </Button>
                </Grid2>
            </Grid2>
            {(isBulkAssign && !assignInProgress && filteredRows.length>0) && <Grid2 container spacing={2} sx={{marginTop:'1%'}}>
                <Grid2 item>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={processBulkAssign}
                        sx={{
                            height: '46px', marginLeft:'auto',
                            textTransform: 'none', width:'150px',
                            borderRadius: '8px', border: '1px solid #0dba78',
                            backgroundColor: '#EFFBF7', boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: '#EFFBF7',
                            },
                        }}
                    >
                        <Typography sx={{color:'#0dba78'}}>Bulk Assign</Typography>
                    </Button>
                </Grid2>
            </Grid2>}

            {(isBulkAssign && assignInProgress && filteredRows.length>0) && 
            <Grid2 container spacing={2} sx={{ marginTop: '1%' }}>
                <Grid2 item size={12} sx={{ width: '100%' }}>
                    <Paper elevation={0} sx={{
                        border: '1px solid #0065ff',
                        backgroundColor: '#F3F8FF',
                        borderRadius: '8px',
                        px: 2,
                        py: 1.5
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography sx={{ color: '#0065ff', fontWeight: 500 }}>Processing bulk assignment...</Typography>
                            </Box>
                        </Box>
                        <LinearProgress sx={{ mt: 0.5, height: 6, borderRadius: '4px',
                            backgroundColor: '#F3F8FF',
                            '& .MuiLinearProgress-bar': { backgroundColor: '#0065ff' }
                        }} />
                    </Paper>
                </Grid2>
            </Grid2>
            }

            {(openAddModal) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleCloseAddModal}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                {/* <Typography variant="h6" style={{ marginBottom: '24px', marginTop: '8px', fontWeight: 'bold' }}>
                                    {'Add Booking'}
                                </Typography> */}

                                <Grid2 item>
                                    <Typography sx={{color:'#000', fontWeight:'500', fontSize:'20px' }}>Enter User Details</Typography>
                                </Grid2>

                                {clientId==188 && 
                                    <Grid2 item container 
                                    sx={{alignItems:'center'}}
                                    >
                                        <Typography sx={{color:'#83888E'}}>Search by phone number</Typography>
                                        <Switch
                                            checked={!searchByClient}
                                            onChange={() => setSearchByClient(!searchByClient)}
                                        />
                                    </Grid2>
                                }

                                <Grid2 container spacing={2} sx={{marginTop:'1%'}}>
                                    {!searchByClient && 
                                        <Grid2 item size={6.5}>
                                            <PhoneInput
                                                defaultCountry={country_code || "IN"}
                                                style={{
                                                    // width: '380px',  // Set width
                                                    height: '44px',  // Set height
                                                    fontSize: '16px',
                                                    alignItems:'normal'
                                                }}
                                                placeholder=" Enter phone number"
                                                value={customerPhone}
                                                onChange={setCustomerPhone}
                                            />
                                        </Grid2>
                                    }

                                    {searchByClient && 
                                        <Grid2 item size={6.5}>
                                            <TextField
                                                label="Enter Client ID"
                                                value={userCodeSearch}
                                                onChange={(e) => setUserCodeSearch(e.target.value)}
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiInputBase-root': {
                                                        height: '44px',  // Reduced from default
                                                        fontSize: '14px',
                                                        alignItems: 'center'
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        transform: 'translate(14px, 10px) scale(1)',  // Adjust label position
                                                        '&.MuiInputLabel-shrink': {
                                                            transform: 'translate(14px, -9px) scale(0.75)',  // Adjust shrunk label position
                                                        },
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '8px 6px'
                                                    },
                                                }}                                            
                                            />
                                        </Grid2>
                                    }

                                    <Grid2 item size={5.5}>
                                        <Button sx={{textTransform:'none', borderRadius:'8px', width:'100%',
                                        color:'#0065FF', height: '44px', border:'1px solid #0065FF'}} onClick={searchByPhone}>
                                            Fetch Details
                                        </Button>
                                    </Grid2>
                                </Grid2>


                                {(panel_customer_specific_address==1 && userByPhone) && (
                                    <>
                                        <Typography sx={{color: '#83888E', fontSize:'16px', marginTop:'1%'}}>Enter Locations</Typography>
                                        <Grid2 container spacing={2}>
                                            <Grid2 item size={remove_add_stops == 1 ? 6 : 5}>
                                                <Select
                                                    sx={{
                                                        marginTop: '1%',
                                                        height: '50px',
                                                        borderRadius:'12px',
                                                        backgroundColor: '#FFFFFF',
                                                        '& .MuiSelect-select': {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }
                                                    }} fullWidth
                                                    value={pickupLocation}
                                                    onChange={(e) => {
                                                        const nextPickupId = e.target.value;
                                                        setVehicleId('');
                                                        setVehicleType('');
                                                        // Validate against first stop BEFORE committing state
                                                        const selectedLocation = pickupLocationData.find(location => location.id === nextPickupId);
                                                        if (selectedLocation) {
                                                            const lat = parseFloat(selectedLocation.latitude);
                                                            const lng = parseFloat(selectedLocation.longitude);
                                                            if (!isNaN(lat) && !isNaN(lng)) {
                                                                // If there are no stops and pickup-drop < 100m, clear drop instead of blocking
                                                                try {
                                                                    const hasStopIds = Array.isArray(stopIds) && stopIds.length > 0 && stopIds.some(s => s.locationId || (s.latitude && s.longitude));
                                                                    const hasManualStops = Array.isArray(stops) && stops.some(s => s.latitude && s.longitude);
                                                                    const noStops = !hasStopIds && !hasManualStops;
                                                                    if (noStops && dropLatLng && window.google && window.google.maps && window.google.maps.geometry) {
                                                                        const distPD = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                                            new window.google.maps.LatLng(lat, lng),
                                                                            new window.google.maps.LatLng(dropLatLng.lat, dropLatLng.lng)
                                                                        );
                                                                        if (distPD < 100) {
                                                                            // Clear drop since it's too close to the chosen pickup and no stops exist
                                                                            setDropLocation('');
                                                                            setDropLatLng(null);
                                                                        }
                                                                    }
                                                                } catch (_) { /* ignore */ }
                                                                // Determine first stop (prefer stopIds, else manual stops)
                                                                let firstStop = null;
                                                                let firstStopId = 1;
                                                                if (stopIds && stopIds.length > 0 && (stopIds[0].locationId || (stopIds[0].latitude && stopIds[0].longitude))) {
                                                                    firstStopId = stopIds[0].stop_id || 1;
                                                                    const s = stopIds[0];
                                                                    if (s.latitude && s.longitude) {
                                                                        firstStop = { lat: parseFloat(s.latitude), lng: parseFloat(s.longitude) };
                                                                    } else if (s.locationId) {
                                                                        const m = pickupDropLocationData.find(loc => loc.id === s.locationId);
                                                                        if (m && m.latitude && m.longitude) {
                                                                            firstStop = { lat: parseFloat(m.latitude), lng: parseFloat(m.longitude) };
                                                                        }
                                                                    }
                                                                } else if (stops && stops.length > 0 && stops[0].latitude && stops[0].longitude) {
                                                                    firstStopId = stops[0].stop_id || 1;
                                                                    firstStop = { lat: parseFloat(stops[0].latitude), lng: parseFloat(stops[0].longitude) };
                                                                }

                                                                if (firstStop && window.google && window.google.maps && window.google.maps.geometry) {
                                                                    const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                                        new window.google.maps.LatLng(lat, lng),
                                                                        new window.google.maps.LatLng(firstStop.lat, firstStop.lng)
                                                                    );
                                                                    if (dist < 100) {
                                                                        setMessage(`Distance is within 100m. First remove the stop with stop ID ${firstStopId}`);
                                                                        showSnackbar(true);
                                                                        return; // Block selecting this pickup
                                                                    }
                                                                }

                                                                // Passed validation: commit state
                                                                setPickupLocation(nextPickupId);
                                                                setPickupLatLng({ lat, lng });
                                                            } else {
                                                                console.error('Invalid pickup coordinates:', selectedLocation);
                                                            }
                                                        }
                                                    }}
                                                    displayEmpty
                                                    renderValue={(selected) => (
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <img src={pickupMarker} alt="pickup marker" width="20" height="20" />
                                                            {selected ? pickupLocationData.find(loc => loc.id === selected)?.address_name : 
                                                                <Typography sx={{ color: '#666' }}>Select Pickup Address</Typography>}
                                                        </Box>
                                                    )}
                                                    
                                                >
                                                    <MenuItem value="" disabled>
                                                        <Typography sx={{ color: '#666' }}>Select Pickup Address</Typography>
                                                    </MenuItem>
                                                    {pickupLocationData.map((location) => (
                                                        <MenuItem key={location.id} value={location.id}>
                                                            {location.address_name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid2>

                                            <Grid2 item size={remove_add_stops == 1 ? 6 : 5}>
                                                <Select
                                                    sx={{
                                                        marginTop: '1%',
                                                        height: '50px',
                                                        borderRadius:'12px',
                                                        backgroundColor: '#FFFFFF',
                                                        '& .MuiSelect-select': {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }
                                                    }} fullWidth
                                                    value={dropLocation}
                                                    onChange={(e) => {
                                                        const nextDropId = e.target.value;
                                                        setVehicleId('');
                                                        setVehicleType('');
                                                        // Find the selected location and validate distance BEFORE committing state
                                                        const selectedLocation = dropLocationData.find(location => location.id === nextDropId);
                                                        if (selectedLocation) {
                                                            const lat = parseFloat(selectedLocation.latitude);
                                                            const lng = parseFloat(selectedLocation.longitude);
                                                            
                                                            // Only proceed if coordinates are valid numbers
                                                            if (!isNaN(lat) && !isNaN(lng)) {
                                                                // If there are no stops at all, enforce pickup vs drop >= 100m
                                                                try {
                                                                    const hasStopIds = Array.isArray(stopIds) && stopIds.length > 0 && stopIds.some(s => s.locationId || (s.latitude && s.longitude));
                                                                    const hasManualStops = Array.isArray(stops) && stops.some(s => s.latitude && s.longitude);
                                                                    const noStops = !hasStopIds && !hasManualStops;
                                                                    if (noStops && pickupLatLng && window.google && window.google.maps && window.google.maps.geometry) {
                                                                        const distPD = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                                            new window.google.maps.LatLng(pickupLatLng.lat, pickupLatLng.lng),
                                                                            new window.google.maps.LatLng(lat, lng)
                                                                        );
                                                                        if (distPD < 100) {
                                                                            setMessage('Pickup and drop must be at least 100m apart');
                                                                            showSnackbar(true);
                                                                            return; // Block selecting this drop
                                                                        }
                                                                    }
                                                                } catch (_) { /* ignore advisory errors */ }
                                                                // Validate against last stop (stopIds preferred, fallback to manual stops)
                                                                let lastStop = null;
                                                                let lastStopId = null;
                                                                if (stopIds && stopIds.length > 0 && (stopIds[stopIds.length - 1].locationId || (stopIds[stopIds.length - 1].latitude && stopIds[stopIds.length - 1].longitude))) {
                                                                    const s = stopIds[stopIds.length - 1];
                                                                    lastStopId = s.stop_id || stopIds.length;
                                                                    if (s.latitude && s.longitude) {
                                                                        lastStop = { lat: parseFloat(s.latitude), lng: parseFloat(s.longitude) };
                                                                    } else if (s.locationId) {
                                                                        const m = pickupDropLocationData.find(loc => loc.id === s.locationId);
                                                                        if (m && m.latitude && m.longitude) {
                                                                            lastStop = { lat: parseFloat(m.latitude), lng: parseFloat(m.longitude) };
                                                                        }
                                                                    }
                                                                } else if (stops && stops.length > 0 && stops[stops.length - 1].latitude && stops[stops.length - 1].longitude) {
                                                                    const s = stops[stops.length - 1];
                                                                    lastStopId = s.stop_id || stops.length;
                                                                    lastStop = { lat: parseFloat(s.latitude), lng: parseFloat(s.longitude) };
                                                                }

                                                                if (lastStop && window.google && window.google.maps && window.google.maps.geometry) {
                                                                    const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                                        new window.google.maps.LatLng(lat, lng),
                                                                        new window.google.maps.LatLng(lastStop.lat, lastStop.lng)
                                                                    );
                                                                    if (dist < 100) {
                                                                        setMessage(`Distance is within 100m. First remove the stop with stop ID ${lastStopId}`);
                                                                        showSnackbar(true);
                                                                        return; // Block selecting this drop
                                                                    }
                                                                }

                                                                // Passed validation: commit state
                                                                setDropLocation(nextDropId);
                                                                setDropLatLng({lat, lng});
                                                            } else {
                                                                console.error('Invalid drop coordinates:', selectedLocation);
                                                            }
                                                        }
                                                    }}
                                                    displayEmpty
                                                    startAdornment={
                                                        <InputAdornment position="start">
                                                            <img src={dropMarker} alt="drop marker" />
                                                        </InputAdornment>
                                                    }
                                                >
                                                    <MenuItem value="" disabled>
                                                        <Typography sx={{ color: '#666' }}>Select Drop Address</Typography>
                                                    </MenuItem>
                                                    {dropLocationData.map((location) => (
                                                        <MenuItem key={location.id} value={location.id}>
                                                            {location.address_name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid2>

                                            {(remove_add_stops!=1) &&  //also make the grid size={5} for both the grids above
                                            <Grid2 item size={2}
                                                sx={{
                                                    border:'1px solid #0065ff', 
                                                    borderRadius:'12px',
                                                    display:'flex', 
                                                    alignItems:'center', 
                                                    justifyContent:'center', 
                                                    cursor:'pointer',
                                                    '&:hover': { backgroundColor: '#f0f7ff' }
                                                }}
                                                onClick={handleAddStopIds}
                                            >
                                                <Typography sx={{color:'#0065ff', textAlign:'center'}}>Add Stop</Typography>
                                            </Grid2>
                                            }
                                        </Grid2>

                                        {stopIds.map((stop, index) => (
                                            <Grid2 container key={stop.stop_id || `stop-${index}-${Date.now()}`} sx={{marginTop:'1%'}}>
                                                <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                                    <span style={{
                                                        display: 'inline-block',
                                                        minWidth: 24,
                                                        minHeight: 24,
                                                        borderRadius: '50%',
                                                        background: '#0065ff',
                                                        color: '#fff',
                                                        fontWeight: 500,
                                                        textAlign: 'center',
                                                        lineHeight: '24px',
                                                        marginRight: 8
                                                    }}>{stop.stop_id || index + 1}</span>
            
                                                    <Select
                                                        sx={{
                                                            marginTop: '1%', height: '50px', borderRadius:'12px', backgroundColor: '#FFFFFF', width:'600px',
                                                            '& .MuiSelect-select': {
                                                                display: 'flex', alignItems: 'center', gap: '8px'
                                                            }
                                                        }} fullWidth value={stop.locationId || ''}
                                                        onChange={(e) => {
                                                            const selectedLocation = pickupDropLocationData.find(location => location.id === e.target.value);
                                                            if (selectedLocation) {
                                                                // Compute distance from previous point (pickup or previous stop)
                                                                const lat = parseFloat(selectedLocation.latitude);
                                                                const lng = parseFloat(selectedLocation.longitude);
                                                                if (!isNaN(lat) && !isNaN(lng)) {
                                                                    let prevPoint = null;
                                                                    if (index === 0) {
                                                                        // Previous is pickup location for first stop
                                                                        if (pickupLatLng && pickupLatLng.lat && pickupLatLng.lng) {
                                                                            prevPoint = { lat: pickupLatLng.lat, lng: pickupLatLng.lng };
                                                                        }
                                                                    } else {
                                                                        const prevStop = stopIds[index - 1];
                                                                        // Prefer coordinates on prevStop; else look up by its locationId
                                                                        if (prevStop && prevStop.latitude && prevStop.longitude) {
                                                                            prevPoint = { lat: parseFloat(prevStop.latitude), lng: parseFloat(prevStop.longitude) };
                                                                        } else if (prevStop && prevStop.locationId) {
                                                                            const prevMatch = pickupDropLocationData.find(loc => loc.id === prevStop.locationId);
                                                                            if (prevMatch && prevMatch.latitude && prevMatch.longitude) {
                                                                                prevPoint = { lat: parseFloat(prevMatch.latitude), lng: parseFloat(prevMatch.longitude) };
                                                                            }
                                                                        }
                                                                    }

                                                                    if (prevPoint && window.google && window.google.maps && window.google.maps.geometry) {
                                                                        const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                                            new window.google.maps.LatLng(prevPoint.lat, prevPoint.lng),
                                                                            new window.google.maps.LatLng(lat, lng)
                                                                        );
                                                                        if (dist < 100) {
                                                                            setMessage('Selected stop is too close to the previous location (< 100m)');
                                                                            showSnackbar(true);
                                                                            return; // Block selection
                                                                        }
                                                                    }

                                                                    // Validate against the next point as well: use next stop if exists,
                                                                    // otherwise (for the last stop) use the drop location when available
                                                                    {
                                                                        let nextPoint = null;
                                                                        if (index < stopIds.length - 1) {
                                                                            const nextStop = stopIds[index + 1];
                                                                            if (nextStop) {
                                                                                if (nextStop.latitude && nextStop.longitude) {
                                                                                    nextPoint = { lat: parseFloat(nextStop.latitude), lng: parseFloat(nextStop.longitude) };
                                                                                } else if (nextStop.locationId) {
                                                                                    const match = pickupDropLocationData.find(loc => loc.id === nextStop.locationId);
                                                                                    if (match && match.latitude && match.longitude) {
                                                                                        nextPoint = { lat: parseFloat(match.latitude), lng: parseFloat(match.longitude) };
                                                                                    }
                                                                                }
                                                                            }
                                                                        } else if (index === stopIds.length - 1 && dropLatLng && typeof dropLatLng.lat === 'number' && typeof dropLatLng.lng === 'number') {
                                                                            nextPoint = { lat: dropLatLng.lat, lng: dropLatLng.lng };
                                                                        }
                                                                        if (nextPoint && window.google && window.google.maps && window.google.maps.geometry) {
                                                                            const distNext = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                                                new window.google.maps.LatLng(nextPoint.lat, nextPoint.lng),
                                                                                new window.google.maps.LatLng(lat, lng)
                                                                            );
                                                                            if (distNext < 100) {
                                                                                setMessage('Selected stop is too close to the next location (< 100m)');
                                                                                showSnackbar(true);
                                                                                return; // Block selection
                                                                            }
                                                                        }
                                                                    }

                                                                    setStopIds(prevStops => {
                                                                        const updatedStops = [...prevStops];
                                                                        updatedStops[index] = {
                                                                            ...stop,
                                                                            locationId: e.target.value,
                                                                            address: selectedLocation.address_name,
                                                                            latitude: lat,
                                                                            longitude: lng
                                                                        };
                                                                        return updatedStops;
                                                                    });
                                                                }
                                                                setVehicleId('');
                                                                setVehicleType('');
                                                            }
                                                        }}
                                                        displayEmpty
                                                    >
                                                        <MenuItem value="" disabled>
                                                            <Typography sx={{ color: '#666' }}>Select Stop</Typography>
                                                        </MenuItem>
                                                        {pickupDropLocationData.map((location) => (
                                                            <MenuItem key={location.id} value={location.id}>
                                                                {location.address_name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
            
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            const stopIndexToRemove = index;
                                                            handleRemoveStopIds(stopIndexToRemove);
                                                        }}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            padding: 0, marginLeft:'2%',
                                                            marginRight: '2%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                        aria-label={`Remove stop ${index + 1}`}
                                                    >
                                                        <img 
                                                            src={SubtractCircleSvg}
                                                            style={{width:'28px',height:'28px'}}
                                                            alt="Remove stop"
                                                        />
                                                    </button>
                                                </Grid2>
                                            </Grid2>
                                        ))}
                                    </>
                                )}

                                {(panel_customer_specific_address!=1 && userByPhone) && (
                                    <>
                                        <Typography sx={{color: '#83888E', fontSize:'16px', marginTop:'1%'}}>Enter Locations</Typography>
                                        <Grid2 container spacing={2} sx={{ marginTop:'1%'}}>
                                            <Grid2 item size={remove_add_stops == 1 ? 6 : 5} sx={{ position: 'relative' }}>
                                                <input
                                                    ref={inputRef}
                                                    type="text"
                                                    placeholder=" Enter Pickup Location"
                                                    style={{
                                                        width:'100%', boxSizing: 'border-box',
                                                        paddingLeft: '32px', // Add space for the icon on the left 
                                                        backgroundImage: `url(${pickupMarker})`, // Replace with your icon URL
                                                        backgroundPosition: '8px center', // Position the icon on the left side
                                                        backgroundRepeat: 'no-repeat', // Prevent the icon from repeating
                                                        backgroundSize: '20px 20px',
                                                        height:'44px',
                                                        borderRadius:'8px',
                                                        border:'1px solid #E6F0FF'
                                                    }}
                                                    value={pickupLocation}
                                                    onChange={(e) => handleInputChange(e, 'pickup')}
                                                />
                                                {showSuggestions && activeInput?.field === 'pickup' && (
                                                    <Paper elevation={3} sx={{ position: 'absolute', zIndex: 1000, width: '100%', mt: 1, maxHeight: '300px', overflowY: 'auto' }}>
                                                        {suggestions.map((suggestion, index) => (
                                                            <MenuItem
                                                                key={suggestion.place_id}
                                                                onClick={() => handleSuggestionClick(suggestion)}
                                                                selected={index === activeSuggestionIndex}
                                                                sx={{
                                                                    '&:hover': { backgroundColor: '#f0f7ff' },
                                                                    cursor: 'pointer',
                                                                    padding: '10px 16px'
                                                                }}
                                                            >
                                                                {suggestion.description}
                                                            </MenuItem>
                                                        ))}
                                                    </Paper>
                                                )}
                                            </Grid2>

                                            <Grid2 item size={remove_add_stops == 1 ? 6 : 5} sx={{ position: 'relative' }}>
                                                <input
                                                    ref={inputDropRef}
                                                    type="text"
                                                    placeholder=" Enter drop Location"
                                                    style={{
                                                        width:'100%', boxSizing: 'border-box',
                                                        paddingLeft: '32px', // Add space for the icon on the left 
                                                        backgroundImage: `url(${dropMarker})`, // Replace with your icon URL
                                                        backgroundPosition: '8px center', // Position the icon on the left side
                                                        backgroundRepeat: 'no-repeat', // Prevent the icon from repeating
                                                        backgroundSize: '20px 20px',
                                                        height:'44px',
                                                        borderRadius:'8px',
                                                        border:'1px solid #E6F0FF'
                                                    }}
                                                    value={dropLocation}
                                                    onChange={(e) => handleInputChange(e, 'drop')}
                                                />
                                                {showSuggestions && activeInput?.field === 'drop' && (
                                                    <Paper elevation={3} sx={{ position: 'absolute', zIndex: 1000, width: '100%', mt: 1, maxHeight: '300px', overflowY: 'auto' }}>
                                                        {suggestions.map((suggestion, index) => (
                                                            <MenuItem
                                                                key={suggestion.place_id}
                                                                onClick={() => handleSuggestionClick(suggestion)}
                                                                selected={index === activeSuggestionIndex}
                                                                sx={{
                                                                    '&:hover': { backgroundColor: '#f0f7ff' },
                                                                    cursor: 'pointer',
                                                                    padding: '10px 16px'
                                                                }}
                                                            >
                                                                {suggestion.description}
                                                            </MenuItem>
                                                        ))}
                                                    </Paper>
                                                )}
                                            </Grid2>

                                            {(remove_add_stops!=1) && 
                                                <Grid2 
                                                    item size={2}
                                                    sx={{
                                                        border:'1px solid #0065ff', 
                                                        borderRadius:'8px', 
                                                        // width:'100px', 
                                                        display:'flex', 
                                                        alignItems:'center', 
                                                        justifyContent:'center', 
                                                        cursor:'pointer',
                                                        '&:hover': { backgroundColor: '#f0f7ff' }
                                                    }}
                                                    onClick={handleAddStop}
                                                >
                                                    <Typography sx={{color:'#0065ff', textAlign:'center'}}>Add Stop</Typography>
                                                </Grid2>
                                            }
                                        </Grid2>
                                        
                                        {/* Display stops */}
                                        {stops.map((stop, index) => (
                                            <Grid2 container key={stop.stop_id || `stop-${index}-${Date.now()}`} sx={{marginTop:'1%', position: 'relative'}}>
                                                <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                                    <span style={{
                                                        display: 'inline-block',
                                                        minWidth: 24,
                                                        minHeight: 24,
                                                        borderRadius: '50%',
                                                        background: '#0065ff',
                                                        color: '#fff',
                                                        fontWeight: 500,
                                                        textAlign: 'center',
                                                        lineHeight: '24px',
                                                        marginRight: 8
                                                    }}>{stop.stop_id || index + 1}</span>
                                                    <input
                                                        ref={el => stopRefs.current[index] = el}
                                                        type="text"
                                                        placeholder={`Stop ${index + 1}`}
                                                        className="filterBtn"
                                                        style={{
                                                            width: '504px', 
                                                            height:'38px',
                                                            paddingLeft: '32px',
                                                            backgroundPosition: '8px center',
                                                            backgroundSize: '20px 20px',
                                                            border: selectedStopIndex === index ? '2px solid #0065FF' : 'inherit'
                                                        }}
                                                        value={stop.location || stop.address || ''}
                                                        onChange={(e) => handleInputChange(e, 'stop', index)}
                                                        onFocus={() => setSelectedStopIndex(index)}
                                                        onBlur={() => setTimeout(() => setSelectedStopIndex(null), 200)}
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            const stopIndexToRemove = index;
                                                            handleRemoveStop(stopIndexToRemove);
                                                        }}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            padding: 0,
                                                            marginRight: '2%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                        aria-label={`Remove stop ${index + 1}`}
                                                    >
                                                        <img 
                                                            src={SubtractCircleSvg}
                                                            style={{width:'28px',height:'28px'}}
                                                            alt="Remove stop"
                                                        />
                                                    </button>
                                                </Grid2>
                                                {showSuggestions && activeInput?.field === 'stop' && activeInput?.index === index && (
                                                    <Paper elevation={3} sx={{ position: 'absolute', top: '100%', left: '32px', zIndex: 1000, width: '504px', mt: 1, maxHeight: '300px', overflowY: 'auto' }}>
                                                        {suggestions.map((suggestion, i) => (
                                                            <MenuItem
                                                                key={suggestion.place_id}
                                                                onClick={() => handleSuggestionClick(suggestion)}
                                                                selected={i === activeSuggestionIndex}
                                                                sx={{
                                                                    '&:hover': { backgroundColor: '#f0f7ff' },
                                                                    cursor: 'pointer',
                                                                    padding: '10px 16px'
                                                                }}
                                                            >
                                                                {suggestion.description}
                                                            </MenuItem>
                                                        ))}
                                                    </Paper>
                                                )}
                                            </Grid2>
                                        ))}

                                    </>
                                )}

                                {modalWayPoints
                                    .filter(waypt => waypt.address && waypt.address.trim() !== '')
                                    .map((waypt, index) => (
                                        <Grid2 
                                            container 
                                            key={waypt.stop_id || `stop-${index}-${Date.now()}`} 
                                            sx={{marginTop: '1%', position: 'relative'}}
                                        >
                                            <Grid2 sx={{
                                                border: '1px solid #D1D1D1', 
                                                padding: '8px 12px', 
                                                borderRadius: '8px', 
                                                marginTop: '6px', 
                                                color: '#4E545D', 
                                                width: '100%'
                                            }}>
                                                <Typography>
                                                    <span style={{fontSize: '14px', color: '#0065ff', marginBottom: '8px'}}>
                                                        Stop {waypt.stop_id} : {" "}
                                                    </span> 
                                                    {waypt.address}
                                                </Typography>
                                            </Grid2>
                                        </Grid2>
                                    ))
                                }

                                <hr style={{background:'#f9f9f9',}}/>

                                {(userByPhone) && (
                                    <>
                                    <Grid2 item container spacing={1} size={12} sx={{marginTop:'2%'}}>
                                        <Grid2 item size={4}>
                                            <Box sx={{display: 'flex', flexDirection: 'column'}}>
                                                <Label style={{fontSize:'14px', color:'#4E545D', marginBottom: '8px'}}>User Name</Label>
                                                <Typography sx={{
                                                    fontSize:'16px', 
                                                    color:'#0065FF', 
                                                    border:'1px solid #0065FF', 
                                                    padding:'8px 12px', 
                                                    borderRadius:'8px',
                                                    // height: '42px',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    {userByPhone.user_name}
                                                </Typography>
                                            </Box>
                                        </Grid2>
                                        <Grid2 item size={4} sx={{display: 'flex', flexDirection: 'column'}}>
                                            <Label style={{fontSize:'14px', color:'#4E545D', marginBottom: '8px'}}>Vehicle Type</Label>
                                            <Select
                                                value={vehicleId}
                                                onChange={(e) => handleChange(e.target.value)}
                                                displayEmpty
                                                sx={{
                                                    width: '100%',
                                                    height: '42px',
                                                    borderRadius: '8px',
                                                    backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'
                                                }}
                                            >
                                                    <MenuItem value="">Select Vehicle</MenuItem>
                                                    {vehicleDetails.map((vehicle) => (
                                                        <MenuItem key={vehicle.vehicle_id} value={vehicle.vehicle_id}>
                                                            {vehicle.vehicle_name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            {/* </Box> */}
                                        </Grid2>
                                        <Grid2 item size={4}>
                                            <Label style={{fontSize:'14px', color:'#4E545D', marginBottom: '8px'}}>Pickup Time</Label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer
                                                    components={['DateTimePicker']}
                                                    sx={{
                                                        '& .MuiStack-root': {
                                                            padding: 0
                                                        }
                                                    }}
                                                >
                                                    <DateTimePicker
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                height: '42px',
                                                                borderRadius: '8px',
                                                                backgroundColor: '#FFFFFF',
                                                                border: 'none',
                                                                width:'210px'
                                                                // fullWidth:true
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '16px',
                                                                padding: '0px 8px',
                                                                color: 'inherit',
                                                            }
                                                        }}
                                                        value={dateTime}
                                                        onChange={(newValue) => { setDateTime(newValue); }}
                                                        ampm={false}
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                placeholder: 'Select date and time'
                                                            }
                                                        }}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </Grid2>
                                    </Grid2>

                                        {(vehicleType && pickupLatLng && dropLatLng && add_pool_users>0) &&
                                            <Grid2 container sx={{borderRadius:'8px', marginTop:'2%', marginBottom:'1%', alignItems:'center', gap: 1, padding:'8px', backgroundColor:'#f9f9f9'}}>

                                                {additionalUserIds.map((u) => {
                                                        const stopId = userStopMapping[u.user_id] ?? userStopMapping[u.user_code];
                                                        
                                                        const stopAddress = (() => {
                                                            if (stopId === 0) {
                                                                const pickupLoc = pickupLocationData.find(loc => loc.id === pickupLocation);
                                                                return `Pickup : ${pickupLoc?.address_name || 'N/A'}`;
                                                            } else if (stopId === -1) {
                                                                const dropLoc = dropLocationData.find(loc => loc.id === dropLocation);
                                                                return `Drop : ${dropLoc?.address_name || 'N/A'}`;
                                                            } else if (stopId) {
                                                                const stop = modalPickupDropLocData.find(s => 
                                                                    s.id == stopId || 
                                                                    s.id?.toString() === stopId?.toString()
                                                                );
                                                                return `Stop : ${u.user_stop}` || `Stop ${stopId}`;
                                                            }
                                                            return 'Not assigned';
                                                        })();

                                                    return (
                                                        <Grid2 item key={u.user_id}>
                                                            <Box sx={{ 
                                                                display: 'flex', 
                                                                alignItems: 'center', 
                                                                gap: 1, 
                                                                px: 1.75, 
                                                                py: 0.75, 
                                                                border: '1px solid #E6F0FF', 
                                                                borderRadius: '16px', 
                                                                background: '#F9FBFF', 
                                                                flexWrap: 'wrap' 
                                                            }}>
                                                                <Box>
                                                                    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#0065ff' }}>
                                                                        {u.user_name || 'User'} (ID: {u.user_id})
                                                                    </Typography>
                                                                    <Typography variant="caption" sx={{ color: '#6B7280', display: 'block', mt: 0.5 }}>
                                                                        {stopAddress}
                                                                    </Typography>
                                                                </Box>
                                                                <IconButton 
                                                                    size="small" 
                                                                    onClick={() => removeAddedClient(u.user_id)} 
                                                                    sx={{ p: 0.2, ml: 'auto' }}
                                                                >
                                                                    <CloseIcon sx={{ fontSize: 16 }} />
                                                                </IconButton>
                                                            </Box>
                                                        </Grid2>
                                                    );
                                                })}
                                                <Grid2 item size={2} sx={{marginLeft:additionalUserIds.length > 0 ?'auto':'inherit'}}>
                                                    <Button
                                                        sx={{
                                                            height:'38px', width:'100px',
                                                            borderRadius:'8px',
                                                            border:'1px solid #000',
                                                            color:'#000',
                                                            textTransform:'none',
                                                            fontSize:'16px'
                                                        }} 
                                                        onClick={handleOpenAddClientModal}
                                                    >
                                                        Add Client
                                                    </Button>
                                                </Grid2>
                                            </Grid2>
                                        }
                                        
                                        {(vehicleType && pickupLatLng && dropLatLng) && (
                                            <Grid2 container>
                                                <Grid2 item size={4}>
                                                    <Label style={{fontSize:'14px', color:'#4E545D', marginBottom: '8px'}}>Select Driver</Label>
                                                    
                                                    <Select 
                                                        sx={{
                                                            marginTop:'2%',
                                                            height: '42px', 
                                                            borderRadius: '8px', 
                                                            backgroundColor: '#FFFFFF',
                                                        }}
                                                            value={assignDriver.driver_id || ''}
                                                            onChange={(e) => {
                                                            const val = e.target.value;
                                                            const selected = mainDriversData?.find(d => d.driver_id === val) || null;
                                                            setAssignDriver({
                                                                ...assignDriver,
                                                                driver_id: selected?.driver_id || val,
                                                                driver_name: selected?.driver_name || '',
                                                                driver_phone_number: selected?.driver_phone_number || selected?.phone_number || '',
                                                                shift_id: selected?.shift_id,
                                                                shift_vehicle_id: selected?.shift_vehicle_id,
                                                            });
                                                        }}
                                                        fullWidth
                                                    >
                                                    {mainDriversData && mainDriversData.map((driver) => (
                                                        <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                            <Typography>
                                                                {driver.driver_name} ({driver.distance_km.toFixed(2)} Km)
                                                            </Typography>
                                                            {(is_driver_debt_limit_enabled==1) &&
                                                                (driver?.driver_wallet_balance < debtLimit) && 
                                                                <Typography 
                                                                    sx={{
                                                                        color: '#eb530daa', 
                                                                        backgroundColor: '#ffebee',
                                                                        padding: '2px 8px',
                                                                        borderRadius: '4px',
                                                                        fontSize: '12px',
                                                                        fontWeight: 'medium', marginLeft:'6px'
                                                                    }}
                                                                >
                                                                    In debt
                                                                </Typography>
                                                            }
                                                        </Box>
                                                        </MenuItem>
                                                    ))}
                                                    </Select>
                                                    {noDriverMessage && (
                                                        <Typography style={{ color: 'red', marginTop: '2px', fontSize:'14px' }}>No drivers available</Typography>
                                                    )}
                                                </Grid2>
                                                <Grid2 item size={4} sx={{marginLeft:'auto'}}>
                                                    <Button 
                                                        sx={{
                                                            textTransform:'none', marginTop:'12%',
                                                            padding:'8px 32px', 
                                                            border:'1px solid #0065FF', 
                                                            backgroundColor:'#F3F8FF',
                                                            color:'#0065FF', 
                                                            width:'100%',
                                                            height: '42px',
                                                            borderRadius: '8px'
                                                        }} 
                                                        onClick={scheduleBooking}
                                                        >
                                                        Schedule Booking
                                                    </Button>
                                                </Grid2>
                                            </Grid2>
                                        )}
                                        
                                    </>
                                )}

                                <Grid2 item sx={{marginTop:'2%', marginBottom:'4%'}}>
                                    {isLoaded ? (
                                        <GoogleMap key={openAddModal ? 'modal-open' : 'modal-closed'}
                                        mapContainerStyle={containerStyle} center={initialcityCenter} zoom={9} onLoad={onLoad} onUnmount={onUnmount}>
                                            
                                            {pickupLatLng && (
                                                <Marker position={pickupLatLng} title="Pickup Location" 
                                                    icon={{
                                                        url: pickupMarker,
                                                        scaledSize: new window.google.maps.Size(30, 30)
                                                    }}
                                                />
                                            )}
                                            
                                            {dropLatLng && (
                                                <Marker position={dropLatLng} title="Drop Location" 
                                                    icon={{
                                                        url: dropMarker,
                                                        scaledSize: new window.google.maps.Size(30, 30) 
                                                    }} 
                                                />
                                            )}
                                            
                                            {/* Display markers for each stop that has coordinates */}
                                            {stops.map((stop, index) => (
                                                stop.latitude && stop.longitude && (
                                                    <Marker 
                                                        key={`stop-${index}`}
                                                        position={{lat: stop.latitude, lng: stop.longitude}} 
                                                        title={`Stop ${index + 1}`}
                                                        icon={{
                                                            // url: mapPin,
                                                            scaledSize: new window.google.maps.Size(20, 20), // Make stop markers larger
                                                            // labelOrigin: new window.google.maps.Point(13, 13),
                                                            // anchor: new window.google.maps.Point(13, 26) // Anchor at bottom center
                                                        }}
                                                        label={{
                                                            text: `${index + 1}`,
                                                            color: 'white',
                                                            fontSize: '12px',
                                                            fontWeight: 'bold'
                                                        }}
                                                        zIndex={10} // Make stop markers appear above the polyline
                                                    />
                                                )
                                            ))}
                                            
                                            {/* Single polyline connecting all points in sequence */}
                                            {routePath.length > 0 && (
                                                <Polyline
                                                    path={routePath}
                                                    options={{
                                                        strokeColor: '#0065FF',
                                                        strokeWeight: 5,
                                                        strokeOpacity: 0.8,
                                                        clickable: false,
                                                        zIndex: 5,
                                                        geodesic: true,
                                                        icons: [{
                                                            icon: {
                                                                path: window.google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                                                                scale: 4,
                                                                strokeColor: '#0065FF',
                                                                strokeWeight: 2
                                                            },
                                                            offset: '100%',
                                                            repeat: '100px'
                                                        }]
                                                    }}
                                                />
                                            )}

                                            {stopIds.map((stopId, index) => {
                                                const matchingLocation = pickupDropLocationData.find(loc => loc.id === stopId.locationId);
                                                if (!matchingLocation || !matchingLocation.latitude || !matchingLocation.longitude) {
                                                    return null;
                                                }
            
                                                const position = {
                                                    lat: parseFloat(matchingLocation.latitude),
                                                    lng: parseFloat(matchingLocation.longitude)
                                                };
            
                                                return (
                                                    <Marker 
                                                        key={`stop-${stopId.stop_id || index}`}
                                                        position={position}
                                                        title={`Stop ${index + 1}`}
                                                        icon={{
                                                            path: window.google.maps.SymbolPath.CIRCLE,
                                                            fillColor: '#0065FF',
                                                            fillOpacity: 1,
                                                            strokeColor: 'white',
                                                            strokeWeight: 2,
                                                            scale: 10,
                                                        }}
                                                        label={{
                                                            text: `${index + 1}`,
                                                            color: 'white',
                                                            fontSize: '12px',
                                                            fontWeight: 'bold'
                                                        }}
                                                        zIndex={10}
                                                    />
                                                );
                                            })}
                                            
                                            {!isNearbyDrivers && driversData && driversData.length > 0 && driversData.map((marker) => {
                                                return (
                                                    <Marker
                                                        key={marker.driver_id}
                                                        position={{ lat: Number(marker.current_latitude), lng: Number(marker.current_longitude) }}
                                                        title={marker.driver_name} // Tooltip text when hovering over the marker
                                                        icon={{
                                                            url: mapPin,
                                                            scaledSize: new window.google.maps.Size(24, 24)
                                                        }}
                                                    />
                                                );
                                            })}

                                            {isNearbyDrivers && driversData && driversData.length > 0 && driversData.map((marker) => {
                                                const vehicleIcon = marker.vehicle_type == 1 ? CarMarker : 
                                                                marker.vehicle_type == 2 ? BikeMarker : AutoMarker;
                                                
                                                return (
                                                    <DriverLabelMarker
                                                        key={marker.driver_id}
                                                        marker={marker}
                                                        mapPin={vehicleIcon}
                                                    />
                                                );
                                            })}

                                        </GoogleMap>
                                        
                                    ): (<></>)}

                                </Grid2>
                            </Paper>
                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container" sx={{ maxHeight:'70vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            {visibleColumns.map((column) => (
                                <TableCell key={column.id} align="center">
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={orderBy === column.id ? order : 'asc'}
                                        onClick={() => handleRequestSort(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredRows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={visibleColumns.length} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            filteredRows
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.engagement_id || row.ride_id}>
                                        {visibleColumns.map((column) => (
                                            <TableCell key={`${row.ride_id}-${column.id}`} align="center">
                                                {renderCellContent(row, column)}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                        )}
                    </TableBody>

                    {/* <TableBody>
                        {filteredRows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={14} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {(rowsPerPage > 0
                            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : filteredRows
                        ).map((row) => {

                            return(
                                <TableRow key={row.tms_client_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.ride_id}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Grid2 container sx={{ width: "auto", minWidth: "180px",alignItems:'center', marginTop:'2%' }}>
                                            <Grid2>
                                                {row.user_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={row.user_image}></Avatar>
                                                }
                                                {!row.user_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile}></Avatar>
                                                }
                                            </Grid2>
                                            <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                <Grid2>
                                                    <Typography sx={{ fontSize:'14px',textAlign:'left' ,backgroundColor:'#FFFFFF',padding:'0px 2px',textDecoration:'#AC8312',borderRadius:"4px"}}><span style={{color:'#9FA3A7'}}>User Id : </span><span style={{color:'#AC8312'}}>{row?.user_id}</span></Typography>
                                                </Grid2>
                                                <Grid2>
                                                    <Typography sx={{color:'#4E545D',fontSize:'16px'}}>{row.user_name}</Typography>
                                                </Grid2>
                                                <Grid2>
                                                    <Typography sx={{ color: "#9FA3A7", fontSize: "12px"}}>{row.user_phone_number}</Typography>
                                                </Grid2>
                                            </Grid2>
                                        </Grid2>
                                    </TableCell>
                                    <TableCell align="center">
                                        {row?.driver_id && (
                                            <Grid2 container sx={{ width: "auto", minWidth: "180px",alignItems:'center' }}>
                                                <Grid2>
                                                    <Grid2>
                                                {row.driver_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={row.driver_image}></Avatar>
                                                }
                                                {!row.driver_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile}></Avatar>
                                                }
                                            </Grid2>
                                                </Grid2>
                                                <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                    <Grid2>
                                                    <Typography sx={{ fontSize:'14px',textAlign:'left' ,backgroundColor:'#FFFFFF',padding:'0px 2px',textDecoration:'#AC8312',borderRadius:"4px"}}><span style={{color:'#9FA3A7'}}>Driver Id : </span><span style={{color:'#AC8312'}}>{row?.driver_id ? row?.driver_id : '--'}</span></Typography>
                                                </Grid2>
                                                    <Grid2>
                                                        <Typography>{row.driver_name}</Typography>
                                                    </Grid2>
                                                    <Grid2>
                                                        <Typography sx={{ color: "#83888E", fontSize: "12px" }}>{row.driver_phone_number}</Typography>
                                                    </Grid2>
                                                </Grid2>
                                            </Grid2>
                                        )}
                                        {!row.driver_id && '--'}
                                    </TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row?.status==1 ? '#0065FF' : row.status==2 ? '#FFA500' : row.status==3 ? '#0DBA78' : row.status==5 ? '#D14545' : row.status==4 ? '#F5BB19' : '#000' }}>{row?.status==1 ? 'Unassigned' : row.status==2 ? 'In Progress' : row.status==3 ? 'Assigned' : row.status==5 ? 'Cancelled' : row.status==4 ? 'Processed and no driver assigned' : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.engagement_status==2 ? '#0065FF' : row.engagement_status==3 ? '#F5BB19' : row.engagement_status==5 ? '#F5BB19' : row.engagement_status==6 ? '#0DBA78' : '#000' }}>{row.engagement_status==2 ? 'Accepted' : row.engagement_status==3 ? 'Arrived' : row.engagement_status==5 ? 'Started' : row.engagement_status==6 ? 'Ended' : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pickup_time ? new Date(row.pickup_time).toLocaleString('en-GB', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true}).replace(',', ' |') : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.pickup_latitude}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.pickup_longitude}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.pickup_address}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.drop_latitude}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.drop_longitude}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.drop_address}</Typography></TableCell>                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.vehicle_type==1 ? 'Taxi' : row.vehicle_type==2 ? 'Bike' : row.vehicle_type==3 ? 'Autos' : row.vehicle_type==4 ? 'Shuttle' : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px'}}>{row.payment_mode==1 ? 'Cash' : row.payment_mode==2 ? 'Online' : '--'}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.ride_distance}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color:'#0065FF' }}>€ {row.estimated_fare}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.promo_id ? row.promo_id : '--'}</Typography></TableCell>
                                    {show_action_schedule_ride_column==1 && (
                                        <TableCell align="center">
                                    {(row.status===1 || row.status===4) && (
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Button 
                                            onClick={() => handleOpenAssignModal(row)}
                                            sx={{
                                                color: '#0065ff', border: '1px solid #0065ff', textTransform: 'none',
                                                borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "140px",
                                                '&:hover': { backgroundColor: '#0065ff', color: 'white' },
                                                '&:active': { backgroundColor: '#0065ff', color: 'white' }, marginRight:'4px'
                                            }}
                                            >
                                                <Typography sx={{ marginRight: '6%' }}>Assign driver</Typography>
                                            </Button>
                                            
                                        </Box>
                                    )}

                                    {row.engagement_status===2 && (
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Button 
                                            onClick={() => handleOpenAssignModal(row, 'reassign')}
                                            sx={{
                                                color: '#0065ff', border: '1px solid #0065ff', textTransform: 'none',
                                                borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "140px",
                                                '&:hover': { backgroundColor: '#0065ff', color: 'white' },
                                                '&:active': { backgroundColor: '#0065ff', color: 'white' }, marginRight:'4px'
                                            }}
                                            >
                                                <Typography sx={{ marginRight: '6%' }}>Reassign driver</Typography>
                                            </Button>

                                            <Button 
                                            onClick={() => handleOpenAssignModal(row, 'unassign')}
                                            sx={{
                                                color: '#0065ff', border: '1px solid #0065ff', textTransform: 'none',
                                                borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "140px",
                                                '&:hover': { backgroundColor: '#0065ff', color: 'white' },
                                                '&:active': { backgroundColor: '#0065ff', color: 'white' }, marginRight:'4px'
                                            }}
                                            >
                                                <Typography sx={{ marginRight: '6%' }}>Unassign driver</Typography>
                                            </Button>
                                            
                                        </Box>
                                    )}
                                    {row.status !=5 && (
                                        <Button 
                                        onClick={() => handleCancelBooking(row)}
                                        sx={{
                                            color: '#D14545', border: '1px solid #D14545', textTransform: 'none', marginTop:'2%',
                                            borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "140px",
                                            '&:hover': { backgroundColor: '#D14545', color: 'white' },
                                            '&:active': { backgroundColor: '#D14545', color: 'white' }, marginRight:'4px'
                                        }}
                                        >
                                            <Typography sx={{ marginRight: '6%' }}>Cancel</Typography>
                                        </Button>
                                    )}
                                        </TableCell>
                                    )}
                                </TableRow>
                            )
                        })}
                    </TableBody> */}
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            filteredRows.length
                        )} of ${filteredRows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                    
                        <div className="pagination-numbers">
                            {page > 1 && (
                                <>
                                    <button onClick={() => handleChangePage(null, 0)} className="pagination-number">
                                        1
                                    </button>
                                    <span className="pagination-dots">...</span>
                                </>
                            )}
                            {[...Array(Math.ceil(filteredRows.length / rowsPerPage))]
                                .map((_, index) => index)
                                .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                                .map((index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleChangePage(null, index)}
                                        className={`pagination-number ${page === index ? 'active' : ''}`}
                                    >
                                        {index + 1}
                                    </button>
                            ))}

                            {page < Math.ceil(filteredRows.length / rowsPerPage) - 2 && (
                                <>
                                    <span className="pagination-dots">...</span>
                                    <button
                                        onClick={() => handleChangePage(null, Math.ceil(filteredRows.length / rowsPerPage) - 1)}
                                        className="pagination-number"
                                    >
                                        {Math.ceil(filteredRows.length / rowsPerPage)}
                                    </button>
                                </>
                            )}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(filteredRows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            {openAssignModal && (
                <div 
                style={{position: 'fixed',top: 65, right:0, height: '100%',width: '38%',backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,overflowY: 'auto',padding: 20
                }}>
                    <Box>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        <IconButton aria-label="close" onClick={handleClose}
                            style={{
                                position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        
                        <Paper sx={{borderRadius:'12px', padding:'16px'}}>
                        <Typography style={{ marginBottom: '6px', marginTop: '6px', fontWeight: '500', fontSize:'24px' }}>
                            {isReassign ? 'Reassign Driver' : 'Assign Driver'}
                        </Typography>
        
                        <Grid container spacing={2} sx={{marginTop:'3%', marginBottom:'2%'}}>
                        <Grid item xs={12} sm={12}>
                            <Label>Select Driver</Label>
                            {(noDriverMessage && !assigningDrivers) && (
                                <Typography style={{ color: 'red', marginTop: '6px' }}>There are no drivers for this timestamp.</Typography>
                            )}
                            {assigningDrivers ? (
                                <>
                                    <Select 
                                        sx={{
                                            marginTop:'2%',
                                            height: '48px', 
                                            borderRadius: '8px', 
                                            backgroundColor: '#FFFFFF',
                                        }}
                                        value={''}
                                        disabled
                                        displayEmpty
                                        fullWidth
                                    >
                                        <MenuItem value="" disabled>Fetching drivers...</MenuItem>
                                    </Select>
                                    <LinearProgress />
                                </>
                            ) : (
                                <Select 
                                    sx={{
                                        marginTop:'2%',
                                        height: '48px', 
                                        borderRadius: '8px', 
                                        backgroundColor: '#FFFFFF',
                                    }}
                                    value={assignDriver.driver_id || ''}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        const selected = driversData?.find(d => d.driver_id === val) || null;
                                        setAssignDriver({
                                            ...assignDriver,
                                            driver_id: selected?.driver_id || val,
                                            driver_name: selected?.driver_name || '',
                                            driver_phone_number: selected?.driver_phone_number || selected?.phone_number || '',
                                            shift_id: selected?.shift_id,
                                            shift_vehicle_id: selected?.shift_vehicle_id,
                                        });
                                    }}
                                    fullWidth
                                    displayEmpty
                                >
                                    {driversData && driversData.length === 0 ? (
                                        <MenuItem value="" disabled>No drivers available</MenuItem>
                                    ) : (
                                        driversData.map((driver) => (
                                            <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                    <Typography>
                                                        {driver.driver_name} ({driver.distance_km.toFixed(3)} Km)
                                                    </Typography>
                                                    {(is_driver_debt_limit_enabled==1) &&
                                                        (driver?.driver_wallet_balance < debtLimit) && 
                                                        <Typography 
                                                            sx={{
                                                                color: '#eb530daa', 
                                                                backgroundColor: '#ffebee',
                                                                padding: '2px 8px',
                                                                borderRadius: '4px',
                                                                fontSize: '12px',
                                                                fontWeight: 'medium'
                                                            }}
                                                        >
                                                            In debt
                                                        </Typography>
                                                    }
                                                </Box>
                                                {/* <Typography sx={{color:'red'}}>{driver.driver_wallet_balance}</Typography> */}
                                            </MenuItem>
                                        ))
                                    )}
                                </Select>
                            )}
                        </Grid>
                        </Grid>

                        {(add_pool_users == 1 && poolUsersData?.length > 0) && 
                            <Grid2 sx={{backgroundColor:"#f9f9f9", padding:'8px'}}>
                                <Typography sx={{fontSize:'14px'}}>{isReassign ? 'Reassigning ' : 'Assigning '} this ride for the following users as well:</Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                    {poolUsersData?.length > 0 && poolUsersData.map((u) => (
                                        <Box key={u.user_id} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.75, py: 0.75, border: '1px solid #E6F0FF', borderRadius: '16px', background: '#F9FBFF' }}>
                                            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#0065ff' }}>
                                                {u.user_name || 'User'}
                                            </Typography>
                                            <Typography sx={{ fontSize: '13px', color: '#6B7280' }}>
                                                (ID: {u.user_id})
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Grid2>
                        }
                        
                        {!noDriverMessage && 
                            <div style={{ marginTop: '12%', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'6%' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    sx={{width: '140px',height: '50px',textTransform: 'none',
                                    fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {/* disabled={isSubmitting} */}
                                    {isSubmitting ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Done'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleClose}
                                    sx={{
                                    width: '140px',
                                    height: '50px',
                                    textTransform: 'none',
                                    fontSize: '16px',
                                    backgroundColor: '#F0F0F0',
                                    color: '#B0B0B0',
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        }
                        {noDriverMessage && (
                            <div style={{ marginTop: '10%', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'6%' }}>
                                {(selectedRow.status !== 5 && selectedRow.status!==2) && (
                                    <Button 
                                    onClick={() => handleCancelBooking(selectedRow)}
                                    sx={{
                                        color: '#D14545',
                                        border: '1px solid #D14545', 
                                        textTransform: 'none',
                                        borderRadius: '8px', 
                                        minWidth: '40px', 
                                        boxShadow: 'none', 
                                        width: "140px",
                                        '&:hover': { 
                                        backgroundColor: '#D14545', 
                                        color: 'white' 
                                        }
                                    }}
                                    >
                                    <Typography>Cancel Ride</Typography>
                                    </Button>
                                )}
                            </div>
                        )}
        
                        </Paper>
                    </div>
                    </Box>
                </div>
            )}

            <Dialog
                open={openUnassign}
                onClose={() => setOpenUnassign(false)}
                aria-labelledby="unassign-booking-dialog-title"
                aria-describedby="unassign-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="unassign-booking-dialog-title" sx={{fontWeight:'bold'}}>Unassign Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText id="unassign-booking-dialog-description">
                        Are you sure you want to unassign driver from this trip? 
                        <br/>
                        {(add_pool_users == 1 && poolUsersData?.length > 0) && 
                            <Grid2 sx={{backgroundColor:"#f9f9f9", padding:'8px', marginTop:'4%', borderRadius:'8px'}}>
                                <Typography sx={{fontSize:'14px'}}>Driver will be unassigned from this trip for the following users as well:</Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                    {poolUsersData?.length > 0 && poolUsersData.map((u) => (
                                        <Box key={u.user_id} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.75, py: 0.75, border: '1px solid #E6F0FF', borderRadius: '16px', background: '#F9FBFF' }}>
                                            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#0065ff' }}>
                                                {u.user_name || 'User'}
                                            </Typography>
                                            <Typography sx={{ fontSize: '13px', color: '#6B7280' }}>
                                                (ID: {u.user_id})
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Grid2>
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenUnassign(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            handleSubmit();
                            setOpenUnassign(false);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        {isSubmitting ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Yes'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openBulkFailedModal}
                onClose={() => setOpenBulkFailedModal(false)}
                aria-labelledby="bulk-failed-dialog-title"
                aria-describedby="bulk-failed-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px',
                        paddingRight:'20px'
                    }
                }}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Rides Assignment Status<hr/></DialogTitle>
                <DialogContent>
                    <DialogContentText id="bulk-failed-dialog-description">
                        <Typography sx={{fontSize:'16px'}}>Bulk assignment has failed.<br/> Please contact support.</Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px', justifyContent:'center'}}>
                    <Button 
                        onClick={() => setOpenBulkFailedModal(false)} 
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#0065ff', width:'100px',
                            borderRadius:'8px',
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#0065ff'
                            }
                        }} autoFocus
                    >
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openCancelBookingModal}
                onClose={() => setOpenCancelBookingModal(false)}
                aria-labelledby="cancel-booking-dialog-title"
                aria-describedby="cancel-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Cancel Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText id="cancel-booking-dialog-description">
                        Are you sure you want to cancel this booking?
                        <br/>
                        {/* {(add_pool_users == 1 && poolUsersData.length > 0) && 
                            <Grid2 sx={{backgroundColor:"#f9f9f9", padding:'8px', marginTop:'4%', borderRadius:'8px'}}>
                                <Typography sx={{fontSize:'14px'}}>Trips will be cancelled for the following users:</Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                    {poolUsersData?.length > 0 && poolUsersData.map((u) => (
                                        <Box key={u.user_id} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.75, py: 0.75, border: '1px solid #E6F0FF', borderRadius: '16px', background: '#F9FBFF' }}>
                                            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#0065ff' }}>
                                                {u.user_name || 'User'}
                                            </Typography>
                                            <Typography sx={{ fontSize: '13px', color: '#6B7280' }}>
                                                (ID: {u.user_id})
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Grid2>
                        } */}
                        <Grid2 container direction="column" spacing={2}>
                            {(hide_fare_on_map_view_cancel == 0) &&
                                <>
                                    <Grid2 container alignItems="center" spacing={1}>
                                        <Grid2 sx={{ width: 180 }}>
                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                Trip Fare:
                                            </Typography>
                                        </Grid2>
                                        <Grid2 sx={{ flex: 1 }}>
                                            <TextField
                                                type="number" disabled
                                                variant="outlined"
                                                value={selectedRow?.estimated_fare}
                                                fullWidth
                                                size="small"
                                            />
                                        </Grid2>
                                    </Grid2>
    
                                    {/* Refund Percentage */}
                                    <Grid2 container alignItems="center" spacing={1}>
                                        <Grid2 sx={{ width: 180 }}>
                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                Refund Percentage:
                                            </Typography>
                                        </Grid2>
                                        <Grid2 sx={{ flex: 1 }}>
                                            <TextField
                                                type="number"
                                                variant="outlined"
                                                value={refundPercentage}
                                                onChange={(e) => setRefundPercentage(e.target.value)}
                                                fullWidth
                                                size="small"
                                            />
                                        </Grid2>
                                    </Grid2>
                                </>
                            }
                        </Grid2>
                    </DialogContentText>

                    <TextField
                        autoFocus
                        margin="dense"
                        id="reason"
                        label="Reason"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={cancelBookingReason}
                        onChange={(e) => setCancelBookingReason(e.target.value)}
                        sx={{ mt: 3 }}
                        />
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenCancelBookingModal(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            handleCancelBookingApi();
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={rideIdUnderProcessModalOpen}
                onClose={() => setRideIdUnderProcessModalOpen(false)}
                aria-labelledby="cancel-booking-dialog-title"
                aria-describedby="cancel-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Ride Under Process<hr/></DialogTitle>
                <DialogContent>
                    <DialogContentText id="cancel-booking-dialog-description">
                        This ride is under process.
                        <br/>
                        Please wait while we are assigning driver to<br/> this ride.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px', justifyContent:'center'}}>
                    <Button 
                        onClick={() => {
                            setRideIdUnderProcessModalOpen(false);
                        }} 
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#0065ff', width:'100px',
                            borderRadius:'8px',
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#0065ff'
                            }
                        }} autoFocus
                    >
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openJobStatusModal}
                onClose={() => setOpenJobStatusModal(false)}
                aria-labelledby="cancel-booking-dialog-title"
                aria-describedby="cancel-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px',
                        paddingRight:'20px'
                    }
                }}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Rides Assignment Status<hr/></DialogTitle>
                <DialogContent>
                    <DialogContentText id="cancel-booking-dialog-description">
                        <Typography sx={{fontSize:'18px'}}>Total rides found: <span style={{fontWeight:'bold', float:'right'}}>{jobStatusOnButtonClick?.meta_data?.result?.rides_found}</span></Typography>
                        <Typography sx={{fontSize:'18px', marginTop:'8px'}}>Failed assignments: <span style={{fontWeight:'bold', float:'right'}}>{jobStatusOnButtonClick?.meta_data?.result?.failed_assignments}</span></Typography>
                        <Typography sx={{fontSize:'18px', marginTop:'8px'}}>Successful assignments: <span style={{fontWeight:'bold', float:'right'}}>{jobStatusOnButtonClick?.meta_data?.result?.successful_assignments}</span></Typography>
                        
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px', justifyContent:'center'}}>
                    <Button 
                        onClick={() => {
                            setOpenJobStatusModal(false);
                            setOpenViewJobStatusModal(true);
                        }} 
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#0065ff', width:'150px',
                            borderRadius:'8px',
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#0065ff'
                            }
                        }} autoFocus
                    >
                        View Details
                    </Button>
                </DialogActions>
            </Dialog>

            <Modal
                open={openViewJobStatusModal}
                onClose={() => {
                    setOpenViewJobStatusModal(false)
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{position:'absolute',top: '50%',left: '50%',transform: 'translate(-50%, -50%)',width: 1000,
                    bgcolor: 'background.paper',border: '2px solid #000',boxShadow: 24,p: 4}}>
                    <IconButton
                        aria-label="close"
                        onClick={() => setOpenViewJobStatusModal(false)}
                        sx={{ position: 'absolute', top: 14, right: 14, color: '#333' }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Grid2 container spacing={6}>
                        <Grid2 item sx={{display:'flex'}}>Total Assignments: {jobStatusOnButtonClick?.meta_data?.result?.rides_found}</Grid2>
                        <Grid2 item sx={{display:'flex'}}>Failed Assignments: {jobStatusOnButtonClick?.meta_data?.result?.failed_assignments}</Grid2>
                        <Grid2 item sx={{display:'flex'}}>Successful Assignments: {jobStatusOnButtonClick?.meta_data?.result?.successful_assignments}</Grid2>
                    </Grid2>
                    <TableContainer className="table-container">
                        <Table stickyHeader className="scrollable-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Ride ID</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Driver ID</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Reason</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {((jobStatusOnButtonClick?.meta_data?.result?.assignments) || []).map((row, idx) => (
                                    <TableRow key={`assign-${row.ride_id || idx}`}>
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.ride_id ?? '-'}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.driver_id ?? '-'}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px', color:'green' }}>{row.status ?? 'Assigned'}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.reason ?? '-'}</Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}

                                {(jobStatusOnButtonClick?.meta_data?.result?.failures || []).map((row, idx) => (
                                    <TableRow key={`fail-${row.ride_id || idx}`}>
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.ride_id ?? '-'}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px' }}>-</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px', color:'red' }}>Failed</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.reason ?? '-'}</Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

            </Modal>

            {/* Add Client Modal */}
            <Modal
                open={addClientModal}
                onClose={() => {
                    handleCloseAddClientModal()
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)', width:{ xs:'90%', sm:520 }, bgcolor:'#FFFFFF', borderRadius:'12px', boxShadow:24, p:3, outline:'none' }}>
                    <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', }}>
                        <Typography sx={{ fontSize:'18px', fontWeight:600, color:'#1A1E25' }}>Add Clients</Typography>
                        <IconButton aria-label="close" onClick={() => handleCloseAddClientModal()} sx={{ color:'#6B7280' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: "#f1f5f9",
                            borderLeft: "4px solid #0065FF",
                            padding: "12px 16px",
                            borderRadius: "6px",
                            marginBottom: 2
                        }}
                        >
                        <Typography sx={{ fontSize: 14, color: "#334155" }}>
                            If the client is being picked up from the same location, click <strong>Add Client</strong>.
                        </Typography>

                        <Typography sx={{ fontSize: 14, color: "#334155", marginTop: "6px" }}>
                            Click <strong>Fetch Stop</strong> only when the pickup location is different.
                        </Typography>
                    </Box>

                    {(add_pool_users>0) && 
                        <Grid2 item container sx={{ alignItems:'center', mb:1 }}>
                            <Typography sx={{color:'#6B7280', fontSize:'14px'}}>Search by phone number</Typography>
                            <Switch
                                checked={!modalSearchByClient}
                                onChange={handleModalSearchByClientToggle}
                                // onChange={() => setModalSearchByClient(!modalSearchByClient)}
                            />
                        </Grid2>
                    }

                    <Grid2 container spacing={2} sx={{ mt:0.5 }}>
                        {!modalSearchByClient && 
                            <Grid2 item size={7.5}>
                                <PhoneInput
                                    defaultCountry={country_code || "IN"}
                                    style={{ height:'44px', fontSize:'16px', alignItems:'normal', width:'100%' }}
                                    placeholder=" Enter phone number"
                                    value={modalCustomerPhone}
                                    onChange={setModalCustomerPhone}
                                />
                            </Grid2>
                        }

                        {modalSearchByClient &&
                            <Grid2 item size={7.5}>
                                <TextField
                                    label="Enter Client ID"
                                    value={modalUserCodeSearch}
                                    onChange={(e) => setModalUserCodeSearch(e.target.value)}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': { height: '44px', fontSize: '14px', alignItems: 'center' },
                                        '& .MuiInputLabel-root': {
                                            transform: 'translate(14px, 10px) scale(1)',
                                            '&.MuiInputLabel-shrink': { transform: 'translate(14px, -9px) scale(0.75)' },
                                        },
                                        '& .MuiInputBase-input': { padding: '8px 6px' },
                                    }}
                                />
                            </Grid2>
                        }

                        <Grid2 item size={4.5}>
                            <Button sx={{textTransform:'none', borderRadius:'8px', width:'100%',
                            color:'#0065FF', height: '44px', border:'1px solid #0065FF'}} onClick={searchAddClient}>
                                Fetch Stops
                            </Button>
                        </Grid2>

                        <Grid2 item size={7.5}>
                            <Select 
                                    value={userStopMapping[modalUserCodeSearch] === 0 ? 'pickup' : 
                                            userStopMapping[modalUserCodeSearch] === -1 ? 'drop' : 
                                            userStopMapping[modalUserCodeSearch] || ''}
                               // In your Select component's onChange handler:
                                onChange={(e) => {
                                const stopValue = e.target.value;
                                
                                setUserStopMapping(prev => {
                                    const newMapping = { ...prev };
                                    
                                    if (stopValue === 'pickup') {
                                        newMapping[modalUserCodeSearch] = 0;
                                    } else if (stopValue === 'drop') {
                                        newMapping[modalUserCodeSearch] = -1;
                                    } else if (parseInt(stopValue) > 0) {
                                        newMapping[modalUserCodeSearch] = parseInt(stopValue);
                                    } else {
                                        delete newMapping[modalUserCodeSearch];
                                    }
                                    
                                    return newMapping;
                                });
                            }}
                                style={{width: '100%', height: '44px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}
                                disabled={!modalUserCodeSearch && !modalCustomerPhone}
                                displayEmpty
                            >
                                <MenuItem value="">Select Stop</MenuItem>
                                    {pickupLocation && (
                                        <MenuItem value="pickup">
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                {/* <img src={pickupMarker} alt="pickup" width={16} /> */}
                                                <span>Pickup: {pickupLocationData.find(loc => loc.id === pickupLocation)?.address_name}</span>
                                            </Box>
                                        </MenuItem>
                                    )}
                                    
                                    {/* Show selected drop location if exists */}
                                    {dropLocation && (
                                        <MenuItem value="drop">
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                {/* <img src={dropMarker} alt="drop" width={16} /> */}
                                                <span>Drop: {dropLocationData.find(loc => loc.id === dropLocation)?.address_name}</span>
                                            </Box>
                                        </MenuItem>
                                    )}
                                {modalPickupDropLocData.length > 0 && modalPickupDropLocData[0]?.address && modalPickupDropLocData
                                    .filter(stop => stop.address && stop.address.trim() !== '')
                                    .map((stop, index) => (
                                        <MenuItem key={stop.id} value={stop.id}>
                                            {stop.address_name} <span style={{color:'#6B7280', fontSize:'12px'}}>(ID: {stop.id})</span>
                                        </MenuItem>
                                    ))
                                }
    
                                {(!stops.length || !stops[0]?.address) && stopIds.length > 0 && stopIds[0]?.locationId && 
                                    stopIds
                                        .filter(stop => stop.locationId && stop.locationId !== '')
                                        .map((stop) => {
                                            const matchingLocation = modalPickupDropLocData.find(loc => loc.id === stop.locationId);
                                            return (
                                                <MenuItem key={`stop-${stop.stop_id}`} value={stop.stop_id}>
                                                    {`${matchingLocation?.address_name || 'Stop'} (Stop ${stop.stop_id})`}
                                                </MenuItem>
                                            );
                                        })
                                }
                            </Select>
                        </Grid2>
                        <Grid2 item size={4.5}>
                            <Button
                                onClick={addingClient}
                                disabled={Boolean(seatCount) && additionalUserIds.length >= Number(seatCount)-1}
                                sx={{
                                    textTransform:'none', borderRadius:'8px', width:'100%', height:'44px',
                                    backgroundColor: '#0065FF', color:'#FFFFFF',
                                    '&:hover': { backgroundColor:'#0856d3' },
                                    '&.Mui-disabled': { backgroundColor:'#E5E7EB', color:'#9CA3AF' }
                                }}
                            >
                                Add Client
                            </Button>
                        </Grid2>
                    </Grid2>

                    {(additionalUserIds && additionalUserIds.length > 0) && (
                        <Box sx={{ mt: 2 }}>
                            <Typography sx={{ mb: 1, fontSize: '14px', color: '#4E545D' }}>
                                Added clients: {additionalUserIds.length}{seatCount ? ` / ${seatCount-1}` : ''}
                            </Typography>
                            <Grid2 container spacing={1}>
                                {additionalUserIds.map((u) => {
                                    const stopId = userStopMapping[u.user_id] ?? userStopMapping[u.user_code];
                                    const stopAddress = (() => {
                                        if (stopId === 0) {
                                            // For pickup
                                            const pickupLoc = pickupLocationData.find(loc => loc.id === pickupLocation);
                                            return `Pickup: ${pickupLoc?.address_name || 'N/A'}`;
                                        } else if (stopId === -1) {
                                            // For drop
                                            const dropLoc = dropLocationData.find(loc => loc.id === dropLocation);
                                            return `Drop: ${dropLoc?.address_name || 'N/A'}`;
                                        } else if (u.user_stop) {
                                            // For regular stops
                                            const stop = modalPickupDropLocData.find((s) => 
                                                s.id == u.user_stop || 
                                                s.id?.toString() === u.user_stop?.toString()
                                            );
                                            return stop?.address_name || `Stop ${u.user_stop}`;
                                        }
                                        return 'Not assigned';
                                    })();

                                    return (
                                        <Grid2 item key={u.user_id}>
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                gap: 1, 
                                                px: 1.75, 
                                                py: 0.75, 
                                                border: '1px solid #E6F0FF', 
                                                borderRadius: '16px', 
                                                background: '#F9FBFF', 
                                                flexWrap: 'wrap' 
                                            }}>
                                                <Box>
                                                    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#0065ff' }}>
                                                        {u.user_name || 'User'} (ID: {u.user_id})
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#6B7280', display: 'block', mt: 0.5 }}>
                                                        {stopAddress}
                                                    </Typography>
                                                </Box>
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => removeAddedClient(u.user_id)} 
                                                    sx={{ p: 0.2, ml: 'auto' }}
                                                >
                                                    <CloseIcon sx={{ fontSize: 16 }} />
                                                </IconButton>
                                            </Box>
                                        </Grid2>
                                    );
                                })}
                            </Grid2>
                        </Box>
                    )}

                    <Button
                        onClick={handleCloseAddClientModal}
                        sx={{
                            textTransform:'none', borderRadius:'8px', width:'100%', mt:3, height:'44px',
                            backgroundColor: '#F3F4F6', color:'#111827',
                            '&:hover': { backgroundColor:'#E5E7EB' }
                        }}
                    >
                        Done
                    </Button>
                </Box>
            </Modal>
            <Dialog
                                open={openDetailsModal}
                                onClose={() => setOpenDetailsModal(false)}
                                maxWidth="md"
                                fullWidth
                                PaperProps={{
                                  sx: { borderRadius: "12px", padding: "10px" }
                                }}
                              >
                                <DialogTitle sx={{ fontWeight: "bold" }}>
                                   Ride Status Logs
                                </DialogTitle>
                        
                                <DialogContent dividers>
                                    <Stepper orientation="vertical">
                                    {steps.length > 0 ?  steps.map((log, index) => (
                                        <Step key={index} active completed>
                                        <StepLabel
                                            StepIconComponent={() => (
                                            <CheckCircleIcon color="success" />
                                            )}
                                        >
                                            <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            >
                                            <Box>
                                                <Typography fontWeight="bold" >
                                                    {getEventTitle(log.event_code)} : {(log.source_app).split("_")[0]} {log.source_app.split("_")[1]}
                                                </Typography>
            
                                                <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                >
                                                {getDescription(log)}
                                                </Typography>
                                            </Box>
            
                                            <Chip
                                                label={formatTime(log.event_time)}
                                                size="small"
                                                sx={{
                                                fontSize: "12px",
                                                backgroundColor: "#F3F4F6"
                                                }}
                                            />
                                            </Box>
                                        </StepLabel>
                                        </Step>
                                    )): 
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            py: 6,
                                            color: '#9FA3A7'
                                        }}
                                        >
                                        <InboxIcon sx={{ fontSize: 60, mb: 2, color: '#D1D5DB' }} />
                
                                        <Typography
                                            variant="h6"
                                            sx={{ fontWeight: 500, color: '#4E545D' }}
                                        >
                                            No Logs Found
                                        </Typography>
                
                                        <Typography
                                            variant="body2"
                                            sx={{ mt: 1, color: '#9FA3A7' }}
                                        >
                                            There are no activity logs available for this ride yet.
                                        </Typography>
                                        </Box>
                                        }
                                    </Stepper>
                                </DialogContent>
                        
                                <DialogActions>
                                  <Button
                                    onClick={() => handleCloseDetailsModal()}
                                    sx={{
                                      borderRadius: "8px",
                                      textTransform: "none"
                                    }}
                                  >
                                    Close
                                  </Button>
                                </DialogActions>
                              </Dialog>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
                        
        </div>
    );
};  

export default ScheduledBookings;